import React, { 
  useEffect, 
  useState, 
  useCallback,
  useRef,     // 26 Jul 2026
  useMemo,       // 11 Oct 2026
 } from "react"
import { useParams, useNavigate } from "react-router-dom"
import useTitle from "@/hooks/useTitle"
import { addIcon, userProfileIcon2 } from "@/assets/img/imgAssets"
import {
  PlusIcon,
  MinusIcon,
  TrashIcon,
  PencilSquareIcon,
  // 26 Jul 2026
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline"
import {
  UserGroupIcon,
  BuildingOffice2Icon,
  ArrowTrendingUpIcon,
  CalendarDaysIcon,
  Square3Stack3DIcon,
  ListBulletIcon,
  SwatchIcon,
  InformationCircleIcon,
  ClockIcon,
  ArrowLeftCircleIcon,
  WrenchIcon,
  RocketLaunchIcon,
  DocumentTextIcon,
  CursorArrowRippleIcon,
  SunIcon,
} from "@heroicons/react/24/solid"
import EtContentEditorLight2 from "@/utils/EtContentEditorLight2"
// import EtBtnFormBasic from "@/components/common/buttons/EtBtnFormBasic"
import { getTimeSince } from "@/utils/EtGetTimeSince"
import { formatDate, formatDateTime } from "@/utils/formatDate"
import PulseLoader from "react-spinners/PulseLoader"
import {
  useGetCoachOrgTrailSessionPadsQuery,
  useUpdateCoachOrgTrailSessionPadMutation,
} from "./coachOrgTrailSessionPadsApiSlice"
import { useGetCoachUserOrgTrailSessionActionsQuery } from "../coachUserOrgTrailSessionActions/coachUserOrgTrailSessionActionsApiSlice" // 01 Sep 2024
import { useGetUserPicQuery } from "../users/usersApiSlice"
import EtDocSelfNoteAllUsersIconSVGComp from "@/assets/img/icons/svgComp/EtDocSelfNoteAllUsersIconSVGComp"
import EtDocSelfUserNoteIconSVGComp from "@/assets/img/icons/svgComp/EtDocSelfUserNoteIconSVGComp"
import EtDocSharedNoteAllUsersIconSVGComp from "@/assets/img/icons/svgComp/EtDocSharedNoteAllUsersIconSVGComp"
import EtDocSharedUserNoteIconSVGComp from "@/assets/img/icons/svgComp/EtDocSharedUserNoteIconSVGComp"
// 26 Aug 2024
import EtCoachEvalIcon2SVGComp from "@/assets/img/icons/svgComp/EtCoachEvalIcon2SVGComp"
// import EtModalCreateUserChallengeCoachEval from "@/components/common/modal/EtModalCreateUserChallengeCoachEval"
import EtModalAddOrUpdateUserChallengeCoachEval from "@/components/common/modal/EtModalAddOrUpdateUserChallengeCoachEval"
// 10 Sep 2024
import EtModalAddOrUpdateCoachUserOrgTrailSessionAction from "@/components/common/modal/EtModalAddOrUpdateCoachUserOrgTrailSessionAction"
import EtCoachUserActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtCoachUserActionIcon1SVGComp"
import EtUserActionListByIdComp from "../userActions/EtUserActionListByIdComp" // 02 Sep 2024 - to show user action progress

import EtUserSessionQNABoard from "../userSessionQNAResponses/EtUserSessionQNABoard" // 28 May 2026
// 11 Aug 2026 - Session Q&A reporting
import EtSessionQNAReportComp from "@/features/reporting/sessionQNAs/EtSessionQNAReportComp"

import { useGetOrgTrailSessionCohortsQuery } from "../orgTrailSessionCohorts/orgTrailSessionCohortsApiSlice" // 22 Jun 2026

import {
  useGetUserTrailSessionPlansQuery,
} from "../userTrailSessions/userTrailSessionPlansApiSlice" // 22 Jun 2026

// 03 Aug 2026
import EtCoachSessionChallengeEvaluations from "./EtCoachSessionChallengeEvaluations"

// 11 Oct 2026 - Cohort assigned Session Reference Content

import {
  useGetOrgTrailSessionContentAssignmentsQuery,
} from "@/pages/admin/orgTrailSessionContentAssignments/orgTrailSessionContentAssignmentsApiSlice"

import {
  useGetSessionReferenceContentQuery,
} from "@/pages/admin/sessionReferenceContent/sessionReferenceContentApiSlice"

import EtUserSessionReferenceContentBoard
  from "@/features/userTrailSessions/EtUserSessionReferenceContentBoard"

// 22 Oct 2026 - Coach User Session Progress Evaluation
import EtCoachUserSessionEvalPanel
  from "@/features/coachUserSessionEvals/EtCoachUserSessionEvalPanel"


// 27 Oct 2026 - Coach User Session Evaluation Trends
import EtCoachUserSessionEvalTrends
  from "@/features/coachUserSessionEvals/EtCoachUserSessionEvalTrends"

// 25 Jun 2026
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)


/*
|--------------------------------------------------------------------------
| Reference ID Helper - 11 Oct 2026
|--------------------------------------------------------------------------
*/

const getReferenceId = value => {

  if (!value) return ""

  if (typeof value === "string") {
    return value
  }

  return String(
    value._id ||
    value.id ||
    ""
  )

}

const EtCoachOrgTrailSessionPadCompProd = () => {
  // First Created - 22 Oct 2024
  // Author - Atul Pandey
  // Inherited from EtCoachOrgTrailSessionPad
  // Updated - 22 Oct 2024 - moved coachId to useParams
  // Updated - 23 Feb 2025 - Copied and Renamed for prod deployment
  // Updated - 19 Jul 2025 - Fixed the list display in editor
  // Updated - 28 May 2026 - changes for user q&a
  // Updated - 22 Jun 2026 - Refinements for cohortId
  // Updated - 23 Jun 2026 - Continued Refinements for cohortId
  // Updated - 25 Jun 2026 - Date format fix - [object Object] issue - dayjs
  // Updated - 04 Jul 2026 - cohortId for coach challenge eval
  // Updated - 21 Jul 2026 - text size options
  // Updated - 26 Jul 2026 - tab reorganization for user specific sections
  // Updated - 03 Aug 2026 - componentized multiple session challenge evals
  // Updated - 11 Aug 2026 - session Q&A report
  // Updated - 17 Aug 2026 - session Q&A report publishing refinements
  // Updated - 18 Aug 2026 - session Q&A report publishing refinements continued
  // Updated - 11 Oct 2026 - session reference content addition
  // Updated - 22 Oct 2026 - Coach User Session Progress Evaluation
  // Updated - 27 Oct 2026 - Coach User Session Evaluation Trends
  // Updated - 28 Oct 2026 - Coach User Session Evaluation JSX placement refinements
  
  // 0 - Set Page Title
  useTitle("Coach Org Trail Session Pad")

  // 1 - Extract params from the URL
  const { coachId, orgId, trailId, sessionId } = useParams()
  // console.log('orgId', orgId)
  // console.log('trailId', trailId)
  // console.log('sessionId', sessionId)

  // 2a - RTK queries - extract and update data mutation
  const {
    data: coachOrgTrailSessionPadsData,
    isLoading,
    isError,
    error,
    refetch, // 27 Aug 2024 -Add refetch to trigger a data refresh
  } = useGetCoachOrgTrailSessionPadsQuery(
    // 22 Jun 2026
    {
      coachId,
      orgId,
      trailId,
      sessionId,
      active: true,
    },
    {
      skip: !coachId || !orgId || !trailId || !sessionId,
    }
  )
  // console.log('coach org trail session data:', coachOrgTrailSessionPadsData)

  // 2b - Extract data from entity adapters
  const coachOrgTrailSessionPads = coachOrgTrailSessionPadsData?.ids.map(
    (id) => {
      const coachOrgTrailSessionPad = coachOrgTrailSessionPadsData?.entities[id]
      return coachOrgTrailSessionPad
    }
  )
  // console.log('coachOrgTrailSessionPads:', coachOrgTrailSessionPads)

  // 2c - Filter Org trail sessions for the selected org trail session
  const filteredCoachOrgTrailSessionPad = coachOrgTrailSessionPads?.find(
    (pad) =>
      pad.coachId._id === coachId &&
      pad.orgId._id === orgId &&
      pad.trailId._id === trailId &&
      pad.sessionId._id === sessionId
  )

  // 2d - 22 Jun 2026 - Org Trail Session Cohort Data to get the cohorts for this pad
  const {
    data: orgTrailSessionCohortsData,
    isLoading: isCohortsLoading,
    isError: isCohortsError,
    error: cohortsError,
  } = useGetOrgTrailSessionCohortsQuery({
    orgId,
    trailId,
    active: true,
  },
  {
    skip: !orgId || !trailId,
  })

  const orgTrailSessionCohorts =
  orgTrailSessionCohortsData?.ids
    ?.map((id) => orgTrailSessionCohortsData.entities[id])
    ?.filter(
      (cohort) =>
        cohort?.orgId?._id === orgId &&
        cohort?.trailId?._id === trailId &&
        cohort?.active !== false
    )
    ?.sort(
      (a, b) =>
        (a?.cohortSequence || 0) - (b?.cohortSequence || 0)
    ) || []

  // 22 Jun 2026 - Data for filtering session users for cohort.
  const {
    data: userTrailSessionPlansData,
    isLoading: isSessionPlansLoading,
    isError: isSessionPlansError,
    error: sessionPlansError,
  } = useGetUserTrailSessionPlansQuery(
    {
      trailId,
      sessionId,
      active: true,
    },
    {
      skip: !trailId || !sessionId,
    }
  )

  const userTrailSessionPlans =
  userTrailSessionPlansData?.ids
    ?.map((id) => userTrailSessionPlansData.entities[id])
    ?.filter((plan) => plan?.active !== false) || []

  // console.log( "Filtered Coach Org Trail Session Pad:", filteredCoachOrgTrailSessionPad)

  // 22 Jun 2026 - State for SelectedCohortId
  const [selectedCohortId, setSelectedCohortId] = useState("")

  // 22 Jun 2026
  useEffect(() => {
    if (!selectedCohortId && orgTrailSessionCohorts.length > 0) {
      setSelectedCohortId(orgTrailSessionCohorts[0]._id)
    }
  }, [selectedCohortId, orgTrailSessionCohorts])

  // 22 Jun 2026
  const selectedCohort =
  orgTrailSessionCohorts.find(
    (cohort) => cohort?._id === selectedCohortId
  ) || null

  // console.log("Selected Cohort:", selectedCohort)
  // console.log("plannedStartDate:", selectedCohort?.plannedStartDate)
  // console.log(
  //   "plannedStartDate type:",
  //   typeof selectedCohort?.plannedStartDate
  // )
  // console.log("plannedEndDate:", selectedCohort?.plannedEndDate)
  // console.log(
  //   "plannedEndDate type:",
  //   typeof selectedCohort?.plannedEndDate
  // )

  /*
  |--------------------------------------------------------------------------
  | 11 Oct 2026 - Session Reference Content For Selected Cohort
  |--------------------------------------------------------------------------
  |
  | The Coach / EtAdmin sees reference content assigned
  | specifically to:
  |
  | Organization + Trail + Session + Selected Cohort
  |
  | This is different from the participant-facing endpoint,
  | which derives eligible cohorts from the logged-in user.
  |
  |--------------------------------------------------------------------------
  */

  const {
    data: cohortContentAssignmentsData,
    isLoading: isContentAssignmentsLoading,
    isError: isContentAssignmentsError,
    error: contentAssignmentsError,
  } = useGetOrgTrailSessionContentAssignmentsQuery(
    {
      orgId,
      trailId,
      sessionId,
      cohortId: selectedCohortId,
    },
    {
      skip:
        !orgId ||
        !trailId ||
        !sessionId ||
        !selectedCohortId,
    }
  )


  /*
  |--------------------------------------------------------------------------
  | Master Session Reference Content
  |--------------------------------------------------------------------------
  |
  | Load the complete reference records, including
  | descriptions, YouTube IDs and reflection prompts.
  |
  |--------------------------------------------------------------------------
  */

  const {
    data: sessionReferenceContentData,
    isLoading: isReferenceContentLoading,
    isError: isReferenceContentError,
    error: referenceContentError,
  } = useGetSessionReferenceContentQuery(
    {
      sessionId,
    },
    {
      skip:
        !sessionId ||
        !selectedCohortId,
    }
  )


  /*
  |--------------------------------------------------------------------------
  | Normalize Cohort Assignments
  |--------------------------------------------------------------------------
  */

  const cohortContentAssignments = useMemo(
    () => {

      return (
        cohortContentAssignmentsData?.ids || []
      )
        .map(
          id =>
            cohortContentAssignmentsData.entities[id]
        )
        .filter(Boolean)

    },
    [cohortContentAssignmentsData]
  )


  /*
  |--------------------------------------------------------------------------
  | Normalize Master Reference Content
  |--------------------------------------------------------------------------
  */

  const sessionReferenceContent = useMemo(
    () => {

      return (
        sessionReferenceContentData?.ids || []
      )
        .map(
          id =>
            sessionReferenceContentData.entities[id]
        )
        .filter(Boolean)

    },
    [sessionReferenceContentData]
  )


  /*
  |--------------------------------------------------------------------------
  | Resolve Active Content Assigned To Selected Cohort
  |--------------------------------------------------------------------------
  |
  | Only active assignments and active master content
  | associated with the selected cohort are displayed.
  |
  | Never display all master content without matching
  | it to the cohort assignment.
  |
  |--------------------------------------------------------------------------
  */

  const assignedSessionReferenceContent = useMemo(
    () => {

      if (!selectedCohortId) {
        return []
      }

      const assignedReferenceIds = new Set(

        cohortContentAssignments
          .filter(
            assignment =>

              assignment.active !== false &&

              getReferenceId(assignment.orgId) === orgId &&

              getReferenceId(assignment.trailId) === trailId &&

              getReferenceId(assignment.sessionId) === sessionId &&

              getReferenceId(assignment.cohortId) === selectedCohortId
          )
          .map(
            assignment =>
              getReferenceId(
                assignment.referenceContentId
              )
          )
          .filter(Boolean)

      )

      return sessionReferenceContent
        .filter(
          content =>

            content.active !== false &&

            getReferenceId(content.sessionId) === sessionId &&

            assignedReferenceIds.has(
              getReferenceId(content)
            )
        )
        .slice()
        .sort(
          (a, b) =>
            (a.displayOrder ?? 0) -
            (b.displayOrder ?? 0)
        )

    },
    [
      cohortContentAssignments,
      sessionReferenceContent,
      orgId,
      trailId,
      sessionId,
      selectedCohortId,
    ]
  )

  // 3 - Local state to hold form data
  const [formData, setFormData] = useState({
    coachSessionSelfNotes: "",
    coachSessionAllUsersNotes: "",
    sessionUsers: [],
    // Add other fields as needed
  })

  // 4 - Handler for form inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  // 22 Jun 2026
  if (isLoading || isCohortsLoading || isSessionPlansLoading) {
    return <PulseLoader color={"#ea580c"} />
  }

  if (isError || isCohortsError || isSessionPlansError) {
    return (
      <div>
        Error occurred:{" "}
        {error?.data?.message ||
          cohortsError?.data?.message ||
          sessionPlansError?.data?.message}
      </div>
    )
  }

  // if (isLoading) return <PulseLoader color={"#ea580c"} />
  // if (isError) return <div>Error occurred: {error?.data?.message}</div>

  return (
    <div className="m-1 p-1 bg-gray-200 rounded">
      <EtCoachOrgTrailSessionPadForm
        padData={filteredCoachOrgTrailSessionPad}
        refetch={refetch}
        // 22 Jun 2026
        cohorts={orgTrailSessionCohorts}
        selectedCohort={selectedCohort}
        selectedCohortId={selectedCohortId}
        setSelectedCohortId={setSelectedCohortId}
        userTrailSessionPlans={userTrailSessionPlans}
        
        // 11 Oct 2026 - Cohort assigned Session Reference Content

        sessionReferenceContent={assignedSessionReferenceContent}

        isReferenceContentLoading={
          isContentAssignmentsLoading ||
          isReferenceContentLoading
        }

        referenceContentLoadError={
          isContentAssignmentsError
            ? (
                contentAssignmentsError?.data?.message ||
                "Unable to load cohort content assignments."
              )
            : isReferenceContentError
              ? (
                  referenceContentError?.data?.message ||
                  "Unable to load Session Reference Content."
                )
              : ""
        }
      />
    </div>
  )
}

const EtCoachOrgTrailSessionPadForm = ({ 
  padData, 
  refetch,
  // 22 Jun 2026
  cohorts=[],
  selectedCohort,
  selectedCohortId, 
  setSelectedCohortId,
  userTrailSessionPlans = [],

  // 11 Oct 2026 - Session Reference Content
  sessionReferenceContent = [],
  isReferenceContentLoading = false,
  referenceContentLoadError = "",
}) => {
  // First Created - 09 Aug 2024
  // Author - Atul Pandey
  // Updated - 10 Aug 2024 - Added Coach Session Note mutation and form components
  // Updated - 25 Aug 2024 - Added Coach Session Challenge Evaluation for a specific org trail session
  // Updated - 26 Aug 2024 - Added Coach evaluation section along with modal to create new evaluations
  // Updated - 27 Aug 2024 - Refcactored display to include Challenge Instructions and Dimension Headers
  // Updated - 01 Sep 2024 - Added Coach Session Planned Actions for all users in a session
  // Updated - 02 Sep 2024 - Added the coach session planned action creation modal
  // Updated - 02 Sep 2024 - Added the coach session
  // Updated - 10 Sep 2024 - Added filter to the session user to exclude coach who is from the same org as that of users
  // Updated - 13 Sep 2024 - Refined display of Coach's notes based on the note length
  // Updated - 13 Sep 2024 - Added state variables to toggle show / hide coach all users note details
  // Updated - 13 Sep 2024 - Added state variables to toggle show / hide coach self note (all users) details
  // Updated - 13 Sep 2024 - Added state variables to toggle show / hide coach shared note details for specific user
  // Updated - 13 Sep 2024 - Added state variables to toggle show / hide coach self note details for specific user
  // Updated - 07 Mar 2025 - fixed the sessionId (added to filter out non matching sessions)
  // Updated - 19 Jul 2025 - Fixed the list display in editor
  // Updated - 28 May 2026 - Refinements for session q&a
  // Updated - 22 Jun 2026 - Refinements for cohortId
  // Updated - 23 Jun 2026 - Continued Refinements for cohortId
  // Updated - 25 Jun 2026 - Date format fix - [object Object] issue - dayjs
  // Updated - 04 Jul 2026 - cohortId for coach challenge eval
  // Updated - 21 Jul 2026 - text size options
  // Updated - 26 Jul 2026 - tab reorganization for user specific sections
  // Updated - 03 Aug 2026 - componentized multiple session challenge evals
  // Updated - 11 Aug 2026 - session Q&A report
  // Updated - 17 Aug 2026 - session Q&A report publishing refinements
  // Updated - 18 Aug 2026 - session Q&A report publishing refinements continued
  // Updated - 22 Oct 2026 - Coach User Session Progress Evaluation
  // Updated - 27 Oct 2026 - Coach User Session Evaluation Trends
  // Updated - 28 Oct 2026 - Coach User Session Evaluation JSX placement refinements


  // 1a1 - 26 Jul 2026 - Horizontal user carousel references
  const selfNotesUserTabsRef = useRef(null)
  const sharedNotesUserTabsRef = useRef(null)

  // 28 Oct 2026 - Section 2 Session User Progress Tabs
  const sessionUsersTabsRef = useRef(null)



  // 1a2 - state variables for show / hide
  const [showDetails, setShowDetails] = useState(true)
  const [showSessionInfo, setShowSessionInfo] = useState(false)
  const [showSessionUsers, setShowSessionUsers] = useState(false)
  const [showSelfNotes, setShowSelfNotes] = useState(false) // Coach's self notes - for all users
  const [showAllUsersNotes, setShowAllUsersNotes] = useState(false) // Coach's shared notes - for all users
  const [showSelfUserNotes, setShowSelfUserNotes] = useState({}) // Coach's self notes - for specific users - 11 Aug 2024 changed to object from boolean
  const [showSharedUserNotes, setShowSharedUserNotes] = useState({}) // Coach's shared notes - for specific users - 11 Aug 2024 changed to object from boolean
  const [selfEditorKey, setSelfEditorKey] = useState("selfNote-" + Date.now()) // to address multiple editors issue
  const [allUsersEditorKey, setAllUsersEditorKey] = useState(
    "allUsersNote-" + Date.now()
  ) // to address multiple editors issue
  const [selfUserEditorKey, setSelfUserEditorKey] = useState(
    "selfUserNote-" + Date.now()
  ) // 11 Aug 2024 - to address multiple editors issue
  const [sharedUserEditorKey, setSharedUserEditorKey] = useState(
    "sharedUserNote-" + Date.now()
  ) // 11 Aug 2024 - to address multiple editors issue
  const [showUserSections, setShowUserSections] = useState(false) // 11 Aug 2024 - For Section 5 - Specific User sections
  const [showUserSectionDetails, setShowUserSectionDetails] = useState({}) // 11 Aug 2024 - For Section 5 - Specific User sections
  const [showSharedUserSections, setShowSharedUserSections] = useState(false) // 11 Aug 2024 - For Section 5 - Specific SharedUser sections
  const [showSharedUserSectionDetails, setShowSharedUserSectionDetails] =
    useState({}) // 11 Aug 2024 - For Section 5 - Specific SharedUser sections
  const [showCoachEvalsSection, setShowCoachEvalsSection] = useState(false) // 26 Aug 2024 - For Coach's Evaluation
  const [showChallengeSections, setShowChallengeSections] = useState({}) // 26 Aug 2024
  const [showChallengeHeadDetails, setShowChallengeHeadDetails] = useState({}) // 26 Aug 2024
  const [showChallengeHeadSectionDetails, setShowChallengeHeadSectionDetails] =
    useState({}) // 27 Aug 2024
  const [showChallengeDimDetails, setShowChallengeDimDetails] = useState({}) // 26 Aug 2024
  const [selectedUserId, setSelectedUserId] = useState(null) // 26 Aug 2024
  const [selectedUserOrgId, setSelectedUserOrgId] = useState(null) // 26 Aug 2024
  const [selectedChallengeId, setSelectedChallengeId] = useState(null) // 26 Aug 2024
  const [existingEvalData, setExistingEvalData] = useState(null) // 27 Aug 2024 - to allow create / update of coach user challenge evals
  const [mode, setMode] = useState("create") // 27 Aug 2024 - to allow create / update of coach user challenge evals
  const [actionMode, setActionMode] = useState("create") // 10 Sep 2024 - to allow create / update of coach user session planned actions
  const [showInstructionDetails, setShowInstructionDetails] = useState({}) // 19 Aug 2024
  const [existingActionData, setExistingActionData] = useState(null) // 10 Sep 2024 - to pass existing data to the modal

  const [showCoachAllUsersActionsSection, setShowCoachAllUsersActionsSection ] = useState(false) // 01 Sep 2024 - For Section 8
  const [showCoachAllUsersCreatedActions, setShowCoachAllUsersCreatedActions] = useState(false) // 02 Sep 2024 - Section 8
  const [showCoachUserActionUpdate, setShowCoachUserActionUpdate] = useState({}) // 02 Sep 2024 - for showing user action updates for coach planned user actions

  const [showCoachSelfAllUsersNoteDetail, setShowCoachSelfAllUsersNoteDetail] = useState({}) // 13 Sep 2024 - for showing coach self note (for all users) detail when it is >100 chars
  const [showCoachAllUsersNoteDetail, setShowCoachAllUsersNoteDetail] = useState({}) // 13 Sep 2024 - for showing coach note detail when it is >100 chars
  const [showCoachSelfUserNoteDetail, setShowCoachSelfUserNoteDetail] = useState({}) // 13 Sep 2024 - for showing coach self note detail for a specific user when it is >100 chars
  const [showCoachSharedUserNoteDetail, setShowCoachSharedUserNoteDetail] = useState({}) // 13 Sep 2024 - for showing coach shared note detail for a specific user when it is >100 chars

  // 21 Jul 2026 - User selectable display size for all session notes
  const [noteTextSize, setNoteTextSize] = useState("medium")

  const noteTextSizeClasses = {
    small: "text-[11px] leading-5",
    medium: "text-sm leading-6",
    large: "text-base leading-7",
    extraLarge: "text-lg leading-8",
  }

  const selectedNoteTextSizeClass =
    noteTextSizeClasses[noteTextSize] || noteTextSizeClasses.medium

  // 26 Jul 2026 - Active user tabs for user-specific note sections
  const [selectedSelfNotesUserId, setSelectedSelfNotesUserId] = useState(null)
  const [selectedSharedNotesUserId, setSelectedSharedNotesUserId] =
    useState(null)

  // 11 Aug 2026 - Show / hide Session Q&A reporting workspace
  const [
    showSessionQNAReport,
    setShowSessionQNAReport,
  ] = useState(false)  

  // 11 Aug 2026 - Close prior cohort report when cohort changes
  useEffect(() => {
    setShowSessionQNAReport(false)
  }, [selectedCohortId])
  
  

  /*
  |--------------------------------------------------------------------------
  | 28 Oct 2026 - Section 2 Session User Progress Workspace
  |--------------------------------------------------------------------------
  |
  | Independent participant selection for Session Users.
  |
  | The workspace can host multiple progress views.
  |
  | Current Tab:
  | - Coach Session Evaluations
  |
  | Future Tabs:
  | - Other user journey and progress views
  |
  |--------------------------------------------------------------------------
  */

  // Selected participant within Section 2
  const [
    selectedSessionProgressUserId,
    setSelectedSessionProgressUserId,
  ] = useState(null)

  // Active progress tab for selected participant
  const [
    activeSessionProgressTab,
    setActiveSessionProgressTab,
  ] = useState('coachSessionEvals')



  
  // 1b - State for Modal -- 26 Aug 2024
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [triggeringUrl, setTriggeringUrl] = useState(null) // 26 Aug 2024

  const [isActionModalOpen, setIsActionModalOpen] = useState(false) // 02 Sep 2024 for creating Coach Planned Session Action Modal
  const [triggeringActionUrl, setTriggeringActionUrl] = useState(null) // 02 Sep 2024 for creating Coach Planned Session Action Modal

  // 1c - Get coach's user planned actions data - 01 Sep 2024
  const {data: coachUserOrgTrailSessionActionsData, refetch: refetchActions} = useGetCoachUserOrgTrailSessionActionsQuery()
  const coachSessionPlannedActions = coachUserOrgTrailSessionActionsData?.ids?.map((id) => {
    const coachSessionPlannedAction = coachUserOrgTrailSessionActionsData?.entities[id]
    return coachSessionPlannedAction
  })
  // console.log('Coach Session Planned Actions:', coachSessionPlannedActions)

  // 2a - Basic Pad Data
  const coachId = padData?.coachId?._id
  const coachOrgId = padData?.coachId?.userOrgId
  const orgId = padData?.orgId?._id
  const trailId = padData?.trailId?._id
  const sessionId = padData?.sessionId?._id
  const username = padData?.coachId?.username
  const name = padData?.coachId?.name
  const orgName = padData?.orgId?.organizationName
  const trailName = padData?.trailId?.trailName
  const trailPic = padData?.trailId?.pic
  const sessionName = padData?.sessionId?.sessionName
  const sessionPic = padData?.sessionId?.pic


  // 22 Jun 2026 - cohort users from session users
  const selectedCohortSessionPlans = userTrailSessionPlans.filter(
    (plan) =>
      plan?.trailId?._id === trailId &&
      plan?.sessionId?._id === sessionId &&
      plan?.cohortId?._id === selectedCohortId &&
      plan?.active !== false
  )

  const sessionUsers = selectedCohortSessionPlans
    .map((plan) => ({
      userId: plan?.userId,
    }))
    .filter((item) => item?.userId?._id)

  const filteredSessionUsers = sessionUsers.filter(
    (user) => user?.userId?._id !== coachId
  )

  // 03 Aug 2026 - Cohort lookup used by the componentized Coach evaluation workspace
  const userCohortIdByUserId = filteredSessionUsers.reduce(
    (accumulator, user) => {
      const userId = user?.userId?._id

      if (userId && selectedCohortId) {
        accumulator[userId] = selectedCohortId
      }

      return accumulator
    },
    {}
  )

  // 26 Jul 2026 - Default active user for horizontal user tabs
  useEffect(() => {
    const firstUserId = filteredSessionUsers?.[0]?.userId?._id

    if (
      firstUserId &&
      !filteredSessionUsers.some(
        (user) => user?.userId?._id === selectedSelfNotesUserId
      )
    ) {
      setSelectedSelfNotesUserId(firstUserId)
    }

    if (
      firstUserId &&
      !filteredSessionUsers.some(
        (user) => user?.userId?._id === selectedSharedNotesUserId
      )
    ) {
      setSelectedSharedNotesUserId(firstUserId)
    }
  }, [
    filteredSessionUsers,
    selectedCohortId,
    selectedSelfNotesUserId,
    selectedSharedNotesUserId,
  ])

  /*
  |--------------------------------------------------------------------------
  | 28 Oct 2026 - Resolve Selected Session Progress Participant
  |--------------------------------------------------------------------------
  |
  | Default to the first available participant.
  |
  | Preserve the selection while the participant remains
  | part of the selected cohort's session user list.
  |
  | Reset the selection if the participant is no longer
  | part of the current session/cohort.
  |
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    const firstUserId =
      filteredSessionUsers?.[0]?.userId?._id || null

    const selectedUserIsAvailable =
      filteredSessionUsers.some(
        user =>
          user?.userId?._id === selectedSessionProgressUserId
      )

    if (!selectedUserIsAvailable) {

      setSelectedSessionProgressUserId(firstUserId)

    }

  }, [
    filteredSessionUsers,
    selectedSessionProgressUserId,
  ])

  /*
  |--------------------------------------------------------------------------
  | 28 Oct 2026 - Reset Progress Tab On Cohort Change
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    setActiveSessionProgressTab('coachSessionEvals')

  }, [selectedCohortId])

  /*
  |--------------------------------------------------------------------------
  | 28 Oct 2026 - Resolve Selected Session Progress User
  |--------------------------------------------------------------------------
  */

  const selectedSessionProgressUser =
    filteredSessionUsers.find(
      user =>
        user?.userId?._id === selectedSessionProgressUserId
    ) || null

  // 26 Jul 2026
  const selectedSelfNotesUser =
    filteredSessionUsers?.find(
      (user) => user?.userId?._id === selectedSelfNotesUserId
    ) || null

  // 26 Jul 2026
  const selectedSharedNotesUser =
    filteredSessionUsers?.find(
      (user) => user?.userId?._id === selectedSharedNotesUserId
    ) || null

  // 26 Jul 2026 - Scroll user carousels using left and right controls
  const handleScrollUserTabs = (carouselRef, direction) => {
    if (!carouselRef?.current) return

    const scrollDistance = Math.max(
      carouselRef.current.clientWidth * 0.7,
      240
    )

    carouselRef.current.scrollBy({
      left: direction === "left" ? -scrollDistance : scrollDistance,
      behavior: "smooth",
    })
  }

  // console.log('filteredSessionUsers', filteredSessionUsers)
  const userCount = filteredSessionUsers.length
  
  // const sessionUsers = padData?.sessionUsers
  // const filteredSessionUsers = sessionUsers?.filter(user => user.userId._id !== coachId) // 10 Sep 2024
  
  // const userCount = padData?.sessionUsers?.length
  // const userCount = filteredSessionUsers?.length // 10 Sep 2024 - changed to filteredSessionUsers from sessionUsers
  
  const sessionDetails = padData?.sessionId


  // 22 Jun 2026 - Cohort Info
  const cohortName = selectedCohort?.cohortName || "No Cohort Selected"
  const cohortCode = selectedCohort?.cohortCode || ""
  const cohortStatus = selectedCohort?.cohortStatus || ""
  const cohortSequence = selectedCohort?.cohortSequence || 0
  
  
  const cohortStartDate = selectedCohort?.plannedStartDate || null
  const cohortEndDate = selectedCohort?.plannedEndDate || null


  // 25 Jun 2026 - DEBUG
  // console.log("=== COHORT DATE DEBUG IN FORM ===")

  // console.log("selectedCohort:", selectedCohort)

  // console.log("cohortStartDate:", cohortStartDate)
  // console.log("cohortStartDate type:", typeof cohortStartDate)

  // console.log("cohortEndDate:", cohortEndDate)
  // console.log("cohortEndDate type:", typeof cohortEndDate)

  // console.log(
  //   "formatDate(cohortStartDate):",
  //   cohortStartDate ? formatDate(cohortStartDate) : null
  // )

  // console.log(
  //   "formatDate(cohortEndDate):",
  //   cohortEndDate ? formatDate(cohortEndDate) : null
  // )

  // 28 May 2026 - Session QNA Sets
  const sessionQNASets = sessionDetails?.sessionQNASets || []
  const sessionQNASetCount = sessionQNASets?.filter(item => item?.active !== false)?.length || 0

  // 22 Jun 2026 - Revised Notes filtered by cohort:
  const isSelectedCohortNote = (note) =>
  note?.cohortId?._id === selectedCohortId ||
  note?.cohortId === selectedCohortId

  const coachSessionSelfNotes =
    padData?.coachSessionSelfNotes?.filter(isSelectedCohortNote) || []

  const coachSessionAllUsersNotes =
    padData?.coachSessionAllUsersNotes?.filter(isSelectedCohortNote) || []

  const coachSessionSelfUserNotes =
    padData?.coachSessionSelfUserNotes?.filter(isSelectedCohortNote) || []

  const coachSessionSharedUserNotes =
    padData?.coachSessionSharedUserNotes?.filter(isSelectedCohortNote) || []


  // const coachSessionAllUsersNotes = padData?.coachSessionAllUsersNotes // 10 Aug 2024
  // const coachSessionSelfNotes = padData?.coachSessionSelfNotes // 10 Aug 2024
  // const coachSessionSelfUserNotes = padData?.coachSessionSelfUserNotes // 11 Aug 2024
  // const coachSessionSharedUserNotes = padData?.coachSessionSharedUserNotes // 11 Aug 2024
  
  
  const coachSessionEvals = padData?.sessionChallengeCoachEvals // 26 Aug 2024
  const sessionChallenges = padData?.sessionId?.sessionChallenges // 26 Aug 2024

  

  // console.log('Session Users:', sessionUsers)
  // console.log('Filtered Session Users:', filteredSessionUsers)

  // 2b - Filter Coach Planned SessionActions - 01 Sep 2024
  // const filteredCoachUserPlannedActions = coachSessionPlannedActions?.filter(action => action.coachId._id === coachId && action.coachOrgId._id === coachOrgId && action.userOrgId._id === orgId)
  const filteredCoachUserPlannedActions = coachSessionPlannedActions?.filter(action => action.coachId._id === coachId && action.coachOrgId._id === coachOrgId && action.userOrgId._id === orgId && action?.sessionId?._id === sessionId) // 07 Mar 2025 - fixed the sessionId (added to filter out non matching sessions)

  // console.log('Filtered Coach Planned Actions:', filteredCoachUserPlannedActions)

  // 2c - Define and declare Navigation and state variables for Coach notes - 10 Aug 2024
  const navigate = useNavigate()
  const [coachSelfNotes, setCoachSelfNotes] = useState(coachSessionSelfNotes)
  const [coachAllUsersNotes, setCoachAllUsersNotes] = useState(
    coachSessionAllUsersNotes
  )
  const [coachSelfUserNotes, setCoachSelfUserNotes] = useState(
    coachSessionSelfUserNotes
  ) // 11 Aug 2024
  const [coachSharedUserNotes, setCoachSharedUserNotes] = useState(
    coachSessionSharedUserNotes
  ) // 11 Aug 2024
  const [coachEvals, setCoachEvals] = useState(coachSessionEvals) // 26 Aug 2024

  // const [isEditing, setIsEditing] = useState(false)
  const [isSelfNoteEditing, setIsSelfNoteEditing] = useState(false)
  const [isAllUsersNoteEditing, setIsAllUsersNoteEditing] = useState(false)
  const [isSelfUserNoteEditing, setIsSelfUserNoteEditing] = useState({}) // 11 Aug 2024 - updated the state to object from boolean
  const [isSharedUserNoteEditing, setIsSharedUserNoteEditing] = useState({}) // 11 Aug 2024 - updated the state to object from boolean



  // 23 Jun 2026 - useEffect to reset prior cohort notes states.
  useEffect(() => {
    setCoachSelfNotes(coachSessionSelfNotes || [])
    setCoachAllUsersNotes(coachSessionAllUsersNotes || [])
    setCoachSelfUserNotes(coachSessionSelfUserNotes || [])
    setCoachSharedUserNotes(coachSessionSharedUserNotes || [])

    // Reset single-note editors
    setEditorValue("")
    setCurrentSelfNoteId(null)
    setIsSelfNoteEditing(false)

    setAllUsersEditorValue("")
    setCurrentAllUsersNoteId(null)
    setIsAllUsersNoteEditing(false)

    // Reset per-user editors
    setSelfUserEditorValue({})
    setCurrentSelfUserNoteId({})
    setIsSelfUserNoteEditing({})

    setSharedUserEditorValue({})
    setCurrentSharedUserNoteId({})
    setIsSharedUserNoteEditing({})

    // Reset cohort-sensitive expanded user sections
    setShowUserSectionDetails({})
    setShowSelfUserNotes({})
    setShowSharedUserSectionDetails({})
    setShowSharedUserNotes({})

    // Reset note detail expansion
    setShowCoachSelfAllUsersNoteDetail({})
    setShowCoachAllUsersNoteDetail({})
    setShowCoachSelfUserNoteDetail({})
    setShowCoachSharedUserNoteDetail({})

    // 26 Jul 2026
    setSelectedSelfNotesUserId(null)
    setSelectedSharedNotesUserId(null)
  }, [
    // selectedCohortId,
    // coachSessionSelfNotes,
    // coachSessionAllUsersNotes,
    // coachSessionSelfUserNotes,
    // coachSessionSharedUserNotes,
    selectedCohortId,
    padData?._id,
    padData?.updatedAt,
  ])


  // 3a - Update mutation for adding, editing coach's notes and other activities - 10 Aug 2024
  const [updateCoachOrgTrailSessionPad] =
    useUpdateCoachOrgTrailSessionPadMutation()

  // 4a - Editor Value setting based on incoming data -- 10 Aug 2024 - 13 Jun 2024 (repurposed EtUserTrailSessionImplementation code)
  const [editorValue, setEditorValue] = useState(() => {
    const latestNote = coachSessionSelfNotes?.slice(-1)[0]
    return latestNote ? latestNote.coachSelfNoteText : ""
  })

  // 4b - Current Note Id of the note currently in editor -- 10 Aug 2024 - 14 Jun 2024 (repurposed EtUserTrailSessionImplementation code)
  const [currentSelfNoteId, setCurrentSelfNoteId] = useState(() => {
    const latestNote = coachSessionSelfNotes?.slice(-1)[0]
    return latestNote ? latestNote._id : null
  })

  // 4c - Handle Editor Value change
  const handleEditorChange = (value) => {
    setEditorValue(value)
  }

  // 4d - Handle add self note details - 10 Aug 2024
  const handleAddSelfNote = useCallback(() => {
    setEditorValue("")
    setCurrentSelfNoteId(null)
    setIsSelfNoteEditing(true)
    setSelfEditorKey("selfNote-" + Date.now())
  }, [])

  // 4e - Handle edit self note details - 10 Aug 2024
  const handleEditSelfNote = (note) => {
    setEditorValue(note.coachSelfNoteText)
    setCurrentSelfNoteId(note._id)
    setIsSelfNoteEditing(true)
  }

  // 4f - Handle edit self note details - 10 Aug 2024
  const handleDeleteSelfNote = async (noteId) => {
    try {
      const updatedNotes = coachSessionSelfNotes?.filter(
        (note) => note._id !== noteId
      )

      // 23 Jun 2026
      if (!selectedCohortId) {
        alert("Please select an engagement cohort before updating notes.")
        return
      }

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionSelfNotes: updatedNotes,
      }).unwrap()

      setCoachSelfNotes(updatedNotes) // Update the state with the filtered notes
      alert("Note deleted successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to delete the note:", error)
      // Add error handling logic here if needed
    }
  }

  // 4g - Function to handle saving new Note -- 10 Aug 2024 - 14 Jun 2024 -- (repurposed EtUserTrailSessionImplementation code)
  const handleSaveSelfNote = async () => {
    if (editorValue.trim() === "") {
      alert("The editor is blank. Please enter some text before saving.")
      return
    }

    // 23 Jun 2026
    if (!selectedCohortId) {
      alert("Please select an engagement cohort before updating notes.")
      return
    }

    try {
      let updatedNotes
      if (currentSelfNoteId) {
        // Update existing note
        updatedNotes = coachSessionSelfNotes?.map((note) =>
          note._id === currentSelfNoteId
            ? {
                ...note,
                coachSelfNoteText: editorValue,
                coachSelfNoteUpdateDate: new Date(), // 23 Jun 2026
                // implementationNoteUpdateDate: new Date(),
              }
            : note
        )
      } else {
        // Add new note
        const newNote = {
          cohortId: selectedCohortId, // 23 Jun 2026
          coachSelfNoteText: editorValue,
          coachSelfNoteDate: new Date(),
          coachSelfNoteUpdateDate: new Date(),
          
        }
        updatedNotes = [...coachSessionSelfNotes, newNote]
      }

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionSelfNotes: updatedNotes,
      }).unwrap()

      setEditorValue("")
      setIsSelfNoteEditing(false)
      alert("Notes updated successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to update the user session implementation:", error)
      // You can add an error message or any other logic here in case of a failure
    }
  }

  // 4h - Function to handle editing a note -- 14 Jun 2024 --
  const handleCancelEditSelfNote = (note) => {
    setEditorValue("")
    setCurrentSelfNoteId(null)
    setIsSelfNoteEditing(false)
  }

  // 5a - Editor Value setting for All Users Notes based on incoming data
  const [allUsersEditorValue, setAllUsersEditorValue] = useState(() => {
    const latestNote = coachAllUsersNotes?.slice(-1)[0]
    return latestNote ? latestNote.coachAllUsersNoteText : ""
  })

  // 5b - Current Note Id of the note currently in editor for All Users Notes
  const [currentAllUsersNoteId, setCurrentAllUsersNoteId] = useState(() => {
    const latestNote = coachAllUsersNotes?.slice(-1)[0]
    return latestNote ? latestNote._id : null
  })

  // 5c - Handle Editor Value change for All Users Notes
  const handleAllUsersEditorChange = (value) => {
    setAllUsersEditorValue(value)
  }

  // 5d - Handle add All Users note details
  const handleAddAllUsersNote = useCallback(() => {
    setAllUsersEditorValue("")
    setCurrentAllUsersNoteId(null)
    setIsAllUsersNoteEditing(true)
    setAllUsersEditorKey("allUsersNote-" + Date.now())
  }, [])

  // 5e - Handle edit All Users note details
  const handleEditAllUsersNote = (note) => {
    setAllUsersEditorValue(note.coachAllUsersNoteText)
    setCurrentAllUsersNoteId(note._id)
    setIsAllUsersNoteEditing(true)
  }

  // 5f - Handle save All Users note details
  const handleDeleteAllUsersNote = async (noteId) => {
    try {
      const updatedNotes = coachAllUsersNotes?.filter(
        (note) => note._id !== noteId
      )

      // 23 Jun 2026
      if (!selectedCohortId) {
        alert("Please select an engagement cohort before updating notes.")
        return
      }

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachAllUsersNotes: updatedNotes,
      }).unwrap()

      setCoachAllUsersNotes(updatedNotes) // Update the state with the filtered notes
      alert("Note deleted successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to delete the note:", error)
      // Add error handling logic here if needed
    }
  }

  // 5g - Handle save All Users note details
  const handleSaveAllUsersNote = async () => {
    if (allUsersEditorValue.trim() === "") {
      alert("The editor is blank. Please enter some text before saving.")
      return
    }

    // 23 Jun 2026
    if (!selectedCohortId) {
      alert("Please select an engagement cohort before updating notes.")
      return
    }

    try {
      let updatedNotes
      if (currentAllUsersNoteId) {
        // Update existing note
        updatedNotes = coachAllUsersNotes?.map((note) =>
          note._id === currentAllUsersNoteId
            ? {
                ...note,
                coachAllUsersNoteText: allUsersEditorValue,
                coachAllUsersNoteUpdateDate: new Date(),
              }
            : note
        )
      } else {
        // Add new note
        const newNote = {
          cohortId: selectedCohortId, // 23 Jun 2026
          coachAllUsersNoteText: allUsersEditorValue,
          coachAllUsersNoteDate: new Date(),
          coachAllUsersNoteUpdateDate: new Date(),
        }
        updatedNotes = [...coachAllUsersNotes, newNote]
      }

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionAllUsersNotes: updatedNotes,
      }).unwrap()

      setAllUsersEditorValue("")
      setIsAllUsersNoteEditing(false)
      alert("All Users Notes updated successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to update the All Users notes:", error)
    }
  }

  // 5h - Function to handle editing a All Users note
  const handleCancelEditAllUsersNote = (note) => {
    setAllUsersEditorValue("")
    setCurrentAllUsersNoteId(null)
    setIsAllUsersNoteEditing(false)
  }

  // 6a - Editor Value setting for Self User Notes based on incoming data -- 11 Aug 2024
  const [selfUserEditorValue, setSelfUserEditorValue] = useState(() => {
    const initialEditorValues = {}
    if (coachSelfUserNotes) {
      coachSelfUserNotes?.forEach((note) => {
        initialEditorValues[note.userId] = note?.coachSelfUserNoteText || ""
      })
    }
    return initialEditorValues
  })

  // 6b - Current Note Id of the note currently in editor for Self User Notes -- 11 Aug 2024
  const [currentSelfUserNoteId, setCurrentSelfUserNoteId] = useState({})

  // 6c - Handle Editor Value change for Self User Notes -- 11 Aug 2024
  const handleSelfUserEditorChange = (value, userId) => {
    setSelfUserEditorValue((prev) => ({
      ...prev,
      [userId]: value,
    }))
  }

  // 6d - Handle add Self User note details -- 11 Aug 2024
  const handleAddSelfUserNote = useCallback((userId) => {
    setSelfUserEditorValue((prevState) => ({
      ...prevState,
      [userId]: "", // Clear the editor value for this specific userId
    }))
    setCurrentSelfUserNoteId((prevState) => ({
      ...prevState,
      [userId]: null, // Clear the current note ID for this specific userId
    }))
    setIsSelfUserNoteEditing((prevState) => ({
      ...prevState,
      [userId]: true, // Set editing state to true for this specific userId
    }))
    setSelfUserEditorKey("selfUserNote-" + Date.now())
  }, [])

  // 6e - Handle edit Self User note details -- 11 Aug 2024
  const handleEditSelfUserNote = (userId, note) => {
    setSelfUserEditorValue((prevState) => ({
      ...prevState,
      [userId]: note.coachSelfUserNoteText, // Set the editor value to the note's content for this userId
    }))
    setCurrentSelfUserNoteId((prevState) => ({
      ...prevState,
      [userId]: note._id, // Set the current note ID for this specific userId
    }))
    setIsSelfUserNoteEditing((prevState) => ({
      ...prevState,
      [userId]: true, // Set editing state to true for this specific userId
    }))
  }

  // 6f - Handle save Self User note details -- 11 Aug 2024
  const handleDeleteSelfUserNote = async (noteId) => {
    try {
      const updatedNotes = coachSelfUserNotes?.filter(
        (note) => note._id !== noteId
      )

      // 23 Jun 2026
      if (!selectedCohortId) {
        alert("Please select an engagement cohort before updating notes.")
        return
      }
      // console.log('updated notes:', updatedNotes)

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionSelfUserNotes: updatedNotes,
      }).unwrap()

      setCoachSelfUserNotes(updatedNotes) // Update the state with the filtered notes
      alert("Note deleted successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to delete the note:", error)
      // Add error handling logic here if needed
    }
  }

  // 6g - Handle save Self User note details -- 11 Aug 2024
  const handleSaveSelfUserNote = async (userId) => {
    // Access the specific note content for the given userId
    const editorContent = selfUserEditorValue[userId]?.trim()
    if (!editorContent || editorContent === "") {
      alert("The editor is blank. Please enter some text before saving.")
      return
    }

    // 23 Jun 2026
    if (!selectedCohortId) {
      alert("Please select an engagement cohort before updating notes.")
      return
    }

    try {
      let updatedNotes
      if (currentSelfUserNoteId[userId]) {
        // Update existing note
        updatedNotes = coachSelfUserNotes?.map((note) =>
          note._id === currentSelfUserNoteId[userId]
            ? {
                ...note,
                coachSelfUserNoteText: editorContent,
                coachSelfUserNoteUpdateDate: new Date(),
              }
            : note
        )
      } else {
        // Add new note
        const newNote = {
          cohortId: selectedCohortId, // 23 Jun 2026
          userId: userId,
          coachSelfUserNoteText: editorContent,
          coachSelfUserNoteDate: new Date(),
          coachSelfUserNoteUpdateDate: new Date(),
        }
        updatedNotes = [...coachSelfUserNotes, newNote]
      }

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionSelfUserNotes: updatedNotes,
      }).unwrap()

      // setSelfUserEditorValue('');
      setSelfUserEditorValue((prevState) => ({
        ...prevState,
        [userId]: "", // Clear the editor value for this userId
      }))
      setIsSelfUserNoteEditing((prevState) => ({
        ...prevState,
        [userId]: false, // Set editing state to false for this userId
      }))
      alert("Self User Note updated successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to update the All Users notes:", error)
    }
  }

  // 6h - Function to handle editing a Self User note
  
  const handleCancelEditSelfUserNote = (userId) => {
    setSelfUserEditorValue((prevState) => ({
      ...prevState,
      [userId]: "", // Clear the editor value for this userId
    }))
    setCurrentSelfUserNoteId((prevState) => ({
      ...prevState,
      [userId]: null, // Clear the current note ID for this userId
    }))
    setIsSelfUserNoteEditing((prevState) => ({
      ...prevState,
      [userId]: false, // Set editing state to false for this userId
    }))
  }

  // 6i - Handle toggle show user details -- 11 Aug 2024 -- repurposed from EtUserTrailSessionList -- 23 May 2024 --
  const handleToggleUserDetails = (userId) => {
    setShowUserSectionDetails((prev) => ({
      ...prev,
      [userId]: !prev[userId], // Toggle the visibility of the user section
    }))

    setShowSelfUserNotes((prevNotes) => ({
      ...prevNotes,
      [userId]: !prevNotes[userId], // Toggle visibility for the specific user's notes section
    }))
  }

  // 7a - Editor Value setting for Shared User Notes based on incoming data -- 11 Aug 2024
  const [sharedUserEditorValue, setSharedUserEditorValue] = useState(() => {
    const initialEditorValues = {}
    if (coachSharedUserNotes) {
      coachSharedUserNotes?.forEach((note) => {
        initialEditorValues[note.userId] = note?.coachSharedUserNoteText || ""
      })
    }
    return initialEditorValues
  })

  // 7b - Current Note Id of the note currently in editor for Shared User Notes -- 11 Aug 2024
  const [currentSharedUserNoteId, setCurrentSharedUserNoteId] = useState({})

  // 7c - Handle Editor Value change for Shared User Notes -- 11 Aug 2024
  const handleSharedUserEditorChange = (value, userId) => {
    setSharedUserEditorValue((prev) => ({
      ...prev,
      [userId]: value,
    }))
  }

  // 7d - Handle add Shared User note details -- 11 Aug 2024
  const handleAddSharedUserNote = useCallback((userId) => {
    setSharedUserEditorValue((prevState) => ({
      ...prevState,
      [userId]: "", // Clear the editor value for this specific userId
    }))
    setCurrentSharedUserNoteId((prevState) => ({
      ...prevState,
      [userId]: null, // Clear the current note ID for this specific userId
    }))
    setIsSharedUserNoteEditing((prevState) => ({
      ...prevState,
      [userId]: true, // Set editing state to true for this specific userId
    }))
    setSharedUserEditorKey("sharedUserNote-" + Date.now())
  }, [])

  // 7e - Handle edit Shared User note details -- 11 Aug 2024
  const handleEditSharedUserNote = (userId, note) => {
    setSharedUserEditorValue((prevState) => ({
      ...prevState,
      [userId]: note.coachSharedUserNoteText, // Set the editor value to the note's content for this userId
    }))
    setCurrentSharedUserNoteId((prevState) => ({
      ...prevState,
      [userId]: note._id, // Set the current note ID for this specific userId
    }))
    setIsSharedUserNoteEditing((prevState) => ({
      ...prevState,
      [userId]: true, // Set editing state to true for this specific userId
    }))
  }

  // 7f - Handle save Shared User note details -- 11 Aug 2024
  const handleDeleteSharedUserNote = async (noteId) => {
    try {
      const updatedNotes = coachSharedUserNotes?.filter(
        (note) => note._id !== noteId
      )

      // 23 Jun 2026
      if (!selectedCohortId) {
        alert("Please select an engagement cohort before updating notes.")
        return
      }
      // console.log('updated notes:', updatedNotes)

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionSharedUserNotes: updatedNotes,
      }).unwrap()

      setCoachSharedUserNotes(updatedNotes) // Update the state with the filtered notes
      alert("Note deleted successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to delete the note:", error)
      // Add error handling logic here if needed
    }
  }

  // 7g - Handle save Shared User note details -- 11 Aug 2024
  const handleSaveSharedUserNote = async (userId) => {
    // Access the specific note content for the given userId
    const editorContent = sharedUserEditorValue[userId]?.trim()
    if (!editorContent || editorContent === "") {
      alert("The editor is blank. Please enter some text before saving.")
      return
    }

    // 23 Jun 2026
      if (!selectedCohortId) {
        alert("Please select an engagement cohort before updating notes.")
        return
      }

    try {
      let updatedNotes
      if (currentSharedUserNoteId[userId]) {
        // Update existing note
        updatedNotes = coachSharedUserNotes?.map((note) =>
          note._id === currentSharedUserNoteId[userId]
            ? {
                ...note,
                coachSharedUserNoteText: editorContent,
                coachSharedUserNoteUpdateDate: new Date(),
              }
            : note
        )
      } else {
        // Add new note
        const newNote = {
          cohortId: selectedCohortId, // 23 Jun 2026
          userId: userId,
          coachSharedUserNoteText: editorContent,
          coachSharedUserNoteDate: new Date(),
          coachSharedUserNoteUpdateDate: new Date(),
        }
        updatedNotes = [...coachSharedUserNotes, newNote]
      }

      await updateCoachOrgTrailSessionPad({
        coachId,
        orgId,
        trailId,
        sessionId,
        cohortId: selectedCohortId, // 23 Jun 2026
        coachSessionSharedUserNotes: updatedNotes,
      }).unwrap()

      setSharedUserEditorValue((prevState) => ({
        ...prevState,
        [userId]: "", // Clear the editor value for this userId
      }))
      setIsSharedUserNoteEditing((prevState) => ({
        ...prevState,
        [userId]: false, // Set editing state to false for this userId
      }))
      alert("Shared User Note updated successfully")
      window.location.reload()
    } catch (error) {
      console.error("Failed to update the All Users notes:", error)
    }
  }

  // 7h - Function to handle editing a Shared User note
  const handleCancelEditSharedUserNote = (userId) => {
    setSharedUserEditorValue((prevState) => ({
      ...prevState,
      [userId]: "", // Clear the editor value for this userId
    }))
    setCurrentSharedUserNoteId((prevState) => ({
      ...prevState,
      [userId]: null, // Clear the current note ID for this userId
    }))
    setIsSharedUserNoteEditing((prevState) => ({
      ...prevState,
      [userId]: false, // Set editing state to false for this userId
    }))
  }

  // 7i - Handle toggle show user details -- 11 Aug 2024 -- repurposed from EtUserTrailSessionList -- 23 May 2024 --
  const handleToggleSharedUserDetails = (userId) => {
    setShowSharedUserSectionDetails((prev) => ({
      ...prev,
      [userId]: !prev[userId], // Toggle the visibility of the user section
    }))

    setShowSharedUserNotes((prevNotes) => ({
      ...prevNotes,
      [userId]: !prevNotes[userId], // Toggle visibility for the specific user's notes section
    }))
  }

  // 8a - Toggle function to show/hide challenge details - 26 Aug 2024
  const handleToggleChallengeSections = (challengeId) => {
    setShowChallengeSections((prevState) => ({
      ...prevState,
      [challengeId]: !prevState[challengeId],
    }))
  }

  // 8a - Toggle function to show/hide challenge details - 27 Aug 2024
  const handleToggleChallengeHeadSectionDetails = (challengeId) => {
    setShowChallengeHeadSectionDetails((prevState) => ({
      ...prevState,
      [challengeId]: !prevState[challengeId],
    }))
  }

  // 8b - Toggle function to show/hide challenge head details - 26 Aug 2024
  const handleToggleChallengeHeadDetails = (challengeId, headName) => {
    setShowChallengeHeadDetails((prevState) => ({
      ...prevState,
      [`${challengeId}-${headName}`]: !prevState[`${challengeId}-${headName}`],
    }))
  }

  // 8c - Toggle function to show/hide challenge dimension details - 26 Aug 2024
  const handleToggleChallengeDimDetails = (
    challengeId,
    headName,
    dimensionId
  ) => {
    setShowChallengeDimDetails((prevState) => ({
      ...prevState,
      [`${challengeId}-${headName}-${dimensionId}`]:
        !prevState[`${challengeId}-${headName}-${dimensionId}`],
    }))
  }

  // 8d - Toggle Show function for challenge instruction details - 27 Aug 2024
  const handleToggleInstructionDetails = (challengeId) => {
    setShowInstructionDetails((prev) => ({
      ...prev,
      [challengeId]: !prev[challengeId],
    }))
  }

  // 8e - Toggle Show function for challenge instruction details - 03 Sep 2024
  const handleToggleCoachUserActionUpdate = (actionId) => {
    setShowCoachUserActionUpdate((prev) => ({
      ...prev,
      [actionId]: !prev[actionId],
    }))
  }

  // 8f - Toggle Show function for coach's self note details for all users - 13 Sep 2024
  const handleToggleCoachSelfAllUsersNoteDetail = (noteId) => {
    setShowCoachSelfAllUsersNoteDetail((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }

  // 8g - Toggle Show function coach's shared note details for all users - 13 Sep 2024
  const handleToggleCoachAllUsersNoteDetail = (noteId) => {
    setShowCoachAllUsersNoteDetail((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }
  
  // 8h - Toggle Show function for coach's self note details for a specific user - 13 Sep 2024
  const handleToggleCoachSelfUserNoteDetail = (noteId) => {
    setShowCoachSelfUserNoteDetail((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }

  // 8i - Toggle Show function for coach's shared note details for a specific user - 13 Sep 2024
  const handleToggleCoachSharedUserNoteDetail = (noteId) => {
    setShowCoachSharedUserNoteDetail((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }

  // 9a - Handle Evaluate Action to activate modal - 26 Aug 2024 -- updated 27 Aug 2024 - with setMode and setExistingEvalData
  const handleEvaluate = (challengeId, userId, userOrgId) => {
    const currentUrl = window.location.pathname // 26 Aug 2024 - Capture the current URL
    setTriggeringUrl(currentUrl) // 26 Aug 2024 - Set the triggering URL

    // 27 Aug 2024 - Check if there's an existing evaluation for the selected challenge and user
    const existingEval = coachSessionEvals?.find(
      (evalItem) =>
        evalItem.sessionChallengeCoachEvalId.challengeId === challengeId &&
        evalItem.sessionChallengeCoachEvalId.userId === userId
    )

    setIsModalOpen(true)
    // Pass the userId and userOrgId to the modal component
    setSelectedChallengeId(challengeId)
    setSelectedUserId(userId)
    setSelectedUserOrgId(userOrgId)

    // Determine the mode and set existing evaluation data if it exists
    const mode = existingEval ? "update" : "create"
    setMode(mode)
    setExistingEvalData(
      existingEval ? existingEval.sessionChallengeCoachEvalId : null
    )
  }
  // console.log("Existing Eval Data", existingEvalData)

  const handleCloseChallengeEvalModal = () => {
    setIsModalOpen(false)
    setTriggeringUrl(null) // 26 Aug 2024 Reset the triggering URL
    setSelectedChallengeId(null)
    setSelectedUserId(null)
    setSelectedUserOrgId(null)
    // window.location.reload(); // Force the page to reload
    // Refetch the data to get the latest evaluations
    refetch()
  }

  // 9b - Handle Create Coach Planned Action modal - 02 Sep 2024
  const handleCreatePlannedAction = () => {
    const currentUrl = window.location.pathname // 02 Sep 2024 - Capture the current URL
    setTriggeringActionUrl(currentUrl) // 02 Sep 2024 - Set the triggering URL
    setIsActionModalOpen(true)
  }

  // 10 Sep 2024 - changed the modal to handle create / update
  const handleAddOrUpdatePlannedAction = (action) => {
    const currentUrl = window.location.pathname // 02 Sep 2024 - Capture the current URL
    setTriggeringActionUrl(currentUrl) // 02 Sep 2024 - Set the triggering URL
    setIsActionModalOpen(true)
    
    // Determine the mode based on existing coach planned actions data
    const mode = filteredCoachUserPlannedActions.length>0 ? "update" : "create"
    setActionMode(mode)
    setExistingActionData(action)
  }

  const handleCloseCreateActionModal = () => {
    setIsActionModalOpen(false)
    setTriggeringActionUrl(null) // 26 Aug 2024 Reset the triggering URL
    setExistingActionData(null) // 10 Sep 2024
    refetchActions()
  }

  // 10 - Create an object for setting inner HTML
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  // 11 - Function to get the appropriate color class based on the eval score - 26 Aug 2024
  const getColorForScore = (score) => {
    if (score >= 0 && score < 0.9) return "bg-etpx-0"
    if (score >= 0.9 && score < 1.9) return "bg-etpx-1"
    if (score >= 1.9 && score < 2.9) return "bg-etpx-2"
    if (score >= 2.9 && score < 3.9) return "bg-etpx-3"
    if (score >= 3.9 && score < 4.9) return "bg-etpx-4"
    if (score >= 4.9) return "bg-etpx-5" // For score >= 4.9
    return "bg-black" // default
  }

  return (
    <div className="m-1 p-1 bg-white rounded font-poppins">
      <div className="m-1 p-1 bg-gray-300 rounded">
          {/* <div className="m-1 p-1" onClick={() => navigate("/userMagicHome")}> */}
         <div className="m-1 p-1" onClick={() => navigate("/etapp")}> {/* 23 Feb 2025*/}
          <ArrowLeftCircleIcon className="h-5 w-5 text-orange-600 cursor-pointer" />
        </div>
        {/* Coach Header */}
        <div className="grid grid-cols-12 justify-between items-center m-1 p-1">
          <div className="col-span-3 flex justify-start items-center m-1 p-1">
            <div
              onClick={() => setShowDetails((prev) => !prev)}
              className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
            >
              {showDetails ? (
                <MinusIcon className="h-5 w-5 text-orange-600" />
              ) : (
                <PlusIcon className="h-5 w-5 text-orange-600" />
              )}
            </div>
            <div>
              <User username={username} defaultUserPic={userProfileIcon2} />
            </div>
            <div>
              <p className="px-2 mx-2 text-gray-600 font-bold">{name}</p>
              <p className="mx-2 text-[10px] text-gray-400 rounded-full inline-block px-2 border bg-white shadow shadow-gray-400">
                Founder,{" "}
                <span className="text-orange-600">Eternity Solutions</span>
              </p>
            </div>
          </div>
          <div className="col-span-2 flex justify-start items-center">
            <div>
              <p className="text-[10px] text-gray-500 mx-1 px-1">Org:</p>
            </div>
            <div>
              <BuildingOffice2Icon className="h-5 w-5 text-orange-600 m-1" />
            </div>
            <div>
              <p className=" text-gray-600 font-bold">{orgName}</p>
            </div>
          </div>
          <div className="col-span-2 flex justify-start items-center">
            <div>
              <p className="text-[10px] text-gray-500 mx-1 px-1">Trail:</p>
            </div>
            <div>
              <ArrowTrendingUpIcon className="h-5 w-5 text-orange-600 m-1" />
            </div>
            <div className="flex justify-start items-center">
              <div className="flex justify-center item-center rounded-full h-6 w-6 bg-gray-200 hover:bg-gray-50 mx-1">
                <img src={trailPic} alt="" className="h-5 w-5 " />
              </div>
              <div>
                <p className="text-gray-600 font-bold">{trailName}</p>
              </div>
            </div>
          </div>
          <div className="col-span-4 flex justify-start items-center">
            <div>
              <p className="text-[10px] text-gray-500 mx-1 px-1">Session:</p>
            </div>
            <div>
              <CalendarDaysIcon className="h-5 w-5 text-orange-600 m-1" />
            </div>
            <div className="flex justify-start items-center">
              <div className="flex justify-center item-center rounded-full h-6 w-6 bg-gray-200 hover:bg-gray-50 mx-1">
                <img src={sessionPic} alt="" className="h-5 w-5 " />
              </div>
              <div>
                <p className="px-2 mx-2 text-gray-600 font-bold">
                  {sessionName}
                </p>
              </div>
            </div>
          </div>
          <div className="col-span-1 flex justify-start items-center">
            <div>
              <p className="text-[10px] text-gray-500 mx-1 px-1">Users :</p>
            </div>
            <div>
              <UserGroupIcon className="h-5 w-5 text-orange-600 m-1" />
            </div>
            <div className="rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50">
              <p className="text-orange-600 text-[10px]">{userCount}</p>
            </div>
          </div>
        </div>

        {/* 22 Jun 2026 - Selected Cohort */}
        <div className="m-1 p-1 bg-white rounded">
          <div className="grid grid-cols-12 gap-2 items-center m-1 p-1">
            <div className="col-span-3 flex justify-start items-center">
              <div className="mx-1">
                <UserGroupIcon className="h-5 w-5 text-orange-600" />
              </div>

              <div>
                <p className="text-[10px] text-gray-500">Engagement Cohort:</p>
                <p className="text-xs font-bold text-gray-700">
                  {cohortName}
                  {/* {cohortCode ? ` (${cohortCode})` : ""} */}
                </p>
              </div>
            </div>

            <div className="col-span-3">
              <select
                value={selectedCohortId || ""}
                onChange={(e) => setSelectedCohortId(e.target.value)}
                className="w-full text-xs border border-orange-200 rounded px-2 py-1 bg-gray-50 text-gray-700"
              >
                <option value="">Select cohort</option>

                {cohorts.map((cohort, cohortIndex) => (
                  <option key={cohort._id} value={cohort._id}>
                    {/* {cohort.cohortSequence
                      ? `${cohort.cohortSequence}. `
                      : ""} */}
                      {cohortIndex+1} - {" "}
                    {cohort.cohortName}
                    {/* {cohort.cohortCode ? ` (${cohort.cohortCode})` : ""} */}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-2 flex justify-start items-center">
              <p className="text-[10px] text-gray-500 mr-1">Status:</p>
              <p className="text-[10px] text-orange-600 font-semibold">
                {cohortStatus || "Not set"}
              </p>
            </div>

            <div className="col-span-4 flex justify-end items-center">
              {(cohortStartDate || cohortEndDate) && (
                <p className="text-[10px] text-gray-500">
                  <span className="font-bold mx-1 text-gray-800">Planned</span>:{" "}
                  {cohortStartDate
                    ? dayjs.utc(cohortStartDate).format("DD MMMM YYYY")
                    : "Not set"}
                  {" — "}
                  {cohortEndDate
                    ? dayjs.utc(cohortEndDate).format("DD MMMM YYYY")
                    : "Not set"}
                </p>
              )}
            </div>

            {/* <div className="col-span-4 flex justify-end items-center">
              {(cohortStartDate || cohortEndDate) && (
                <p className="text-[10px] text-gray-500">
                  Planned:
                  {cohortStartDate
                    ? ` ${formatDate(cohortStartDate)}`
                    : " Not set"}
                  {" — "}
                  {cohortEndDate
                    ? formatDate(cohortEndDate)
                    : "Not set"}
                </p>
              )}
            </div> */}
          </div>
        </div>

        {showDetails && (
          <div className="m-1 p-1 bg-white rounded">

            {/* 21 Jul 2026 - Session Notes Text Size Selector */}
            <div className="m-1 p-1 flex justify-end items-center">
              <div className="flex items-center gap-1 rounded border border-gray-200 bg-gray-50 px-2 py-1">
                <p className="mr-1 text-[10px] font-semibold text-gray-500">
                  Note text:
                </p>

                {[
                  { value: "small", label: "S", title: "Small text" },
                  { value: "medium", label: "M", title: "Medium text" },
                  { value: "large", label: "L", title: "Large text" },
                  { value: "extraLarge", label: "XL", title: "Extra large text" },
                ].map((sizeOption) => {
                  const isSelected = noteTextSize === sizeOption.value

                  return (
                    <button
                      key={sizeOption.value}
                      type="button"
                      title={sizeOption.title}
                      aria-label={sizeOption.title}
                      aria-pressed={isSelected}
                      onClick={() => setNoteTextSize(sizeOption.value)}
                      className={`min-w-7 rounded px-2 py-1 text-[10px] font-semibold transition ${
                        isSelected
                          ? "bg-orange-600 text-white shadow-sm"
                          : "bg-white text-gray-500 border border-gray-200 hover:border-orange-300 hover:text-orange-600"
                      }`}
                    >
                      {sizeOption.label}
                    </button>
                  )
                })}
              </div>
            </div>

            {/* Section 1 - Session Info */}
            <div className="m-1 p-1 bg-gray-100 rounded">
              <div className="flex justify-between items-center m-1 p-1">
                <div className="flex justify-start items-center m-1 p-1">
                  <div
                    onClick={() => setShowSessionInfo((prev) => !prev)}
                    className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                  >
                    {showSessionInfo ? (
                      <MinusIcon className="h-5 w-5 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-5 w-5 text-orange-600" />
                    )}
                  </div>
                  <div className="mx-1 px-1">
                    <InformationCircleIcon className="h-6 w-6 text-orange-600" />
                  </div>
                  <div>
                    <p className="text-md font-bold text-gray-600 mx-2 px-2">
                      Session Info
                    </p>
                  </div>
                </div>
              </div>
              {showSessionInfo && sessionDetails?.sessionIntro && (
                <div className="bg-white m-1 p-1 rounded">
                  <div className="p-2 grid grid-cols-3 gap-2 justify-center">
                    <div className="mx-2 border-r  border-orange-200 col-span-1 h-full">
                      <div className="flex flex-col justify-start">
                        <div className="flex justify-start items-center  m-1 p-1">
                          <div className="">
                            <Square3Stack3DIcon className="h-5 w-5 text-orange-600" />
                          </div>
                          <p className="m-1 p-1 text-xs text-gray-400 font-bold border-b-2 border-orange-600">
                            Session{" "}
                            <span className="text-orange-600">Detail</span>
                          </p>
                        </div>
                        <p
                          dangerouslySetInnerHTML={createMarkup(
                            sessionDetails?.sessionIntro
                          )}
                          className="text-[10px] text-gray-600"
                        ></p>
                      </div>
                    </div>

                    <div className="mx-2 col-span-1 border-r border-orange-200 h-full">
                      <div className="flex flex-col justify-start">
                        <div className="flex justify-start items-center  m-1 p-1">
                          <div className="">
                            <ListBulletIcon className="h-5 w-5 text-orange-600" />
                          </div>
                          <p className="m-1 p-1 text-xs text-gray-400 font-bold border-b-2 border-orange-600">
                            Session{" "}
                            <span className="text-orange-600">Prework</span>
                          </p>
                        </div>

                        {sessionDetails?.sessionPreWork &&
                          sessionDetails?.sessionPreWork?.map(
                            (item, preWorkIndex) => (
                              <div
                                key={preWorkIndex}
                                className="rounded m-1 p-1 bg-gray-100"
                              >
                                <p className="text-[10px] mx-1">
                                  <span className="font-bold"></span>
                                  {item.prework}
                                </p>
                              </div>
                            )
                          )}
                      </div>
                    </div>

                    <div className="mx-2 col-span-1">
                      <div className="flex flex-col justify-start">
                        <div className="flex justify-start items-center m-1 p-1">
                          <div className="">
                            <SwatchIcon className="h-5 w-5 text-orange-600" />
                          </div>
                          <p className="m-1 p-1 text-xs text-gray-400 font-bold border-b-2 border-orange-600">
                            Session{" "}
                            <span className="text-orange-600">Outcomes</span>
                          </p>
                        </div>

                        {sessionDetails?.sessionOutcomes &&
                          sessionDetails?.sessionOutcomes?.map(
                            (item, outIndex) => (
                              <div
                                key={outIndex}
                                className="rounded m-1 p-1 bg-gray-100"
                              >
                                <p className="text-[10px] mx-1">
                                  {item?.outcome}
                                </p>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          
            {/*
            |--------------------------------------------------------------------------
            | Section 1A - Session Reference Content - 11 Oct 2026
            |--------------------------------------------------------------------------
            |
            | Displays the reference content assigned to the
            | currently selected Organization / Trail / Session / Cohort.
            |
            | Uses the same Trinity playlist and video panel
            | as the participant-facing User Session Board.
            |
            |--------------------------------------------------------------------------
            */}

            {selectedCohortId && (

              <div className="m-1 p-1 bg-gray-100 rounded">

                {isReferenceContentLoading ? (

                  <div className="m-2 p-3 flex justify-center items-center">

                    <PulseLoader
                      color="#ea580c"
                      size={8}
                    />

                  </div>

                ) : referenceContentLoadError ? (

                  <div className="m-2 p-3 bg-red-50 rounded">

                    <p className="text-xs text-red-700">

                      {referenceContentLoadError}

                    </p>

                  </div>

                ) : sessionReferenceContent.length > 0 ? (

                  <EtUserSessionReferenceContentBoard

                    key={`${selectedCohortId}-${sessionId}`}

                    referenceContent={
                      sessionReferenceContent
                    }

                  />

                ) : (

                  <div className="m-2 p-3 bg-white rounded">

                    <p className="text-xs text-gray-500 italic">

                      No Session Reference Content has been
                      assigned to this cohort for this session.

                    </p>

                  </div>

                )}

              </div>

            )}

            
            {/*
            |--------------------------------------------------------------------------
            | Section 2 - Session Users - 28 Oct 2026
            |--------------------------------------------------------------------------
            |
            | Participant-centric session progress workspace.
            |
            | 1. Select participant from horizontal user tabs.
            | 2. Select a progress view for the participant.
            | 3. Show the selected progress workspace.
            |
            | Current progress tab:
            | - Coach Session Evaluations
            |
            | Evaluation trends aggregate private and shared
            | reflection note evaluations for the selected user.
            |
            |--------------------------------------------------------------------------
            */}

            <div className="m-1 rounded bg-gray-100 p-1">

              {/*----------------------------------------------------------
                Section 2 Header
              ----------------------------------------------------------*/}

              <div className="m-1 flex items-center justify-between p-1">

                <div className="flex items-center">

                  <button
                    type="button"
                    onClick={() =>
                      setShowSessionUsers(previous => !previous)
                    }
                    className="mx-2 flex h-7 w-7 items-center justify-center rounded-full hover:bg-white"
                    aria-label={
                      showSessionUsers
                        ? "Collapse Session Users"
                        : "Expand Session Users"
                    }
                  >
                    {showSessionUsers ? (
                      <MinusIcon className="h-5 w-5 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-5 w-5 text-orange-600" />
                    )}
                  </button>

                  <UserGroupIcon className="h-6 w-6 text-orange-600" />

                  <div>

                    <p className="mx-2 text-md font-bold text-gray-600">
                      Session Users
                    </p>

                    <p className="mx-2 text-[10px] italic text-gray-500">
                      Review participant progress, evaluations and journey
                      across the session.
                    </p>

                  </div>

                  <div className="ml-2 flex h-5 w-5 items-center justify-center rounded-full border border-orange-300 bg-gray-50">
                    <p className="text-[10px] text-orange-600">
                      {userCount}
                    </p>
                  </div>

                </div>

              </div>


              {/*
              |--------------------------------------------------------------------------
              | Section 2 Expanded Participant Workspace
              |--------------------------------------------------------------------------
              */}

              {showSessionUsers && (

                <div className="m-1 rounded bg-white p-2">

                  {/*
                  |--------------------------------------------------------------------------
                  | 2A - Horizontal Participant Tabs
                  |--------------------------------------------------------------------------
                  |
                  | Follows the horizontal scrolling tab pattern
                  | already used in Sections 5 and 6.
                  |
                  |--------------------------------------------------------------------------
                  */}

                  <div className="m-1 rounded border border-gray-200 bg-white">

                    <div className="flex items-center gap-1 p-1">

                      {/* Scroll Left */}

                      <button
                        type="button"
                        title="Previous users"
                        aria-label="Scroll to previous users"
                        onClick={() =>
                          handleScrollUserTabs(
                            sessionUsersTabsRef,
                            "left"
                          )
                        }
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
                      >
                        <ChevronLeftIcon className="h-5 w-5" />
                      </button>


                      {/* User Tabs */}

                      <div
                        ref={sessionUsersTabsRef}
                        role="tablist"
                        aria-label="Select participant for session progress"
                        className="flex min-w-0 flex-1 items-stretch gap-1 overflow-x-auto scroll-smooth whitespace-nowrap p-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                      >

                        {filteredSessionUsers.map(user => {

                          const userId = user?.userId?._id

                          const isSelected =
                            selectedSessionProgressUserId === userId

                          return (

                            <button
                              key={userId}
                              type="button"
                              role="tab"
                              aria-selected={isSelected}
                              onClick={() =>
                                setSelectedSessionProgressUserId(userId)
                              }
                              className={`flex shrink-0 items-center gap-2 rounded px-3 py-2 text-left transition ${
                                isSelected
                                  ? "bg-orange-600 text-white shadow-sm"
                                  : "border border-gray-200 bg-gray-50 text-gray-600 hover:border-orange-300 hover:bg-orange-50"
                              }`}
                            >

                              <User
                                username={user.userId?.username}
                                defaultUserPic={userProfileIcon2}
                                compact
                              />

                              <div>

                                <p
                                  className={`text-xs font-bold ${
                                    isSelected
                                      ? "text-white"
                                      : "text-gray-600"
                                  }`}
                                >
                                  {user.userId?.name}
                                </p>

                                <p
                                  className={`text-[9px] ${
                                    isSelected
                                      ? "text-orange-100"
                                      : "text-gray-400"
                                  }`}
                                >
                                  Session Participant
                                </p>

                              </div>

                            </button>

                          )

                        })}

                      </div>


                      {/* Scroll Right */}

                      <button
                        type="button"
                        title="Next users"
                        aria-label="Scroll to next users"
                        onClick={() =>
                          handleScrollUserTabs(
                            sessionUsersTabsRef,
                            "right"
                          )
                        }
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
                      >
                        <ChevronRightIcon className="h-5 w-5" />
                      </button>

                    </div>

                  </div>


                  {/*
                  |--------------------------------------------------------------------------
                  | 2B - Selected Participant Progress Workspace
                  |--------------------------------------------------------------------------
                  */}

                  {selectedSessionProgressUser ? (

                    <div className="m-1 rounded bg-gray-50 p-2">

                      {/* Participant Header */}

                      <div className="mb-3 flex flex-wrap items-center gap-3 rounded bg-white p-3">

                        <User
                          username={
                            selectedSessionProgressUser.userId?.username
                          }
                          defaultUserPic={userProfileIcon2}
                          compact
                        />

                        <div>

                          <p className="text-xs font-bold text-gray-700">
                            {selectedSessionProgressUser.userId?.name}
                          </p>

                          <p className="text-[10px] text-gray-400">
                            {selectedSessionProgressUser.userId?.email}
                          </p>

                        </div>

                      </div>


                      {/*
                      |--------------------------------------------------------------------------
                      | 2C - Participant Progress Tabs
                      |--------------------------------------------------------------------------
                      |
                      | Additional progress views can be added here
                      | without changing the participant navigation.
                      |
                      |--------------------------------------------------------------------------
                      */}

                      <div className="mb-3 rounded border border-gray-200 bg-white p-2">

                        <div
                          role="tablist"
                          aria-label="Participant progress views"
                          className="flex flex-wrap items-center gap-2"
                        >

                          <button
                            type="button"
                            role="tab"
                            aria-selected={
                              activeSessionProgressTab === 'coachSessionEvals'
                            }
                            onClick={() =>
                              setActiveSessionProgressTab(
                                'coachSessionEvals'
                              )
                            }
                            className={`rounded-full border px-4 py-2 text-[11px] font-semibold transition ${
                              activeSessionProgressTab === 'coachSessionEvals'
                                ? "border-orange-600 bg-orange-600 text-white"
                                : "border-gray-200 bg-gray-50 text-gray-600 hover:border-orange-300 hover:bg-orange-50"
                            }`}
                          >
                            Coach Session Evaluations
                          </button>

                          {/*
                          ----------------------------------------------------------
                          Future Progress Tabs
                          ----------------------------------------------------------

                          <button
                            type="button"
                            role="tab"
                            aria-selected={
                              activeSessionProgressTab === 'otherProgress'
                            }
                            onClick={() =>
                              setActiveSessionProgressTab('otherProgress')
                            }
                          >
                            Other Progress
                          </button>

                          ----------------------------------------------------------
                          */}

                        </div>

                      </div>


                      {/*
                      |--------------------------------------------------------------------------
                      | 2D - Coach Session Evaluations
                      |--------------------------------------------------------------------------
                      |
                      | Evaluation trends are consolidated across:
                      |
                      | - coachSessionSelfUserNotes
                      | - coachSessionSharedUserNotes
                      |
                      | Only matrices belonging to the selected:
                      |
                      | Coach + User + Org + Trail + Session + Cohort
                      |
                      | are considered.
                      |
                      |--------------------------------------------------------------------------
                      */}

                      {activeSessionProgressTab === 'coachSessionEvals' && (

                        <div className="rounded bg-white p-2">

                          <EtCoachUserSessionEvalTrends

                            key={[
                              selectedCohortId,
                              selectedSessionProgressUserId,
                              sessionId,
                            ].join('-')}

                            coachId={coachId}

                            userId={selectedSessionProgressUserId}

                            orgId={orgId}

                            trailId={trailId}

                            sessionId={sessionId}

                            cohortId={selectedCohortId}

                          />

                        </div>

                      )}

                    </div>

                  ) : (

                    <div className="m-2 rounded border border-dashed border-gray-200 bg-gray-50 p-4">

                      <p className="text-xs italic text-gray-500">
                        No participant is available for the selected
                        cohort and session.
                      </p>

                    </div>

                  )}

                </div>

              )}

            </div>


            {/* 26 May 2026 - Section 2A - Coach Session QNA Board */}
            {sessionQNASetCount > 0 && (

              <div className="m-1 p-1">

                {/*
                |--------------------------------------------------------------------------
                | Coach Session Q&A Board
                |--------------------------------------------------------------------------
                */}

                  <EtUserSessionQNABoard
                  userId={coachId}
                  userOrgId={coachOrgId}
                  trailId={trailId}
                  sessionId={sessionId}
                  sessionQNASets={sessionQNASets}
                  responseRole="Coach"
                  boardTitle="Coach Session Q&A Board"
                  //25 Jun 2026
                  cohortId={selectedCohortId}
                  cohort={selectedCohort}
                />

                 {/*
                  |--------------------------------------------------------------------------
                  | Session Q&A Reporting - 11 Aug 2026
                  |--------------------------------------------------------------------------
                  */}

                  {/* {selectedCohortId && (
                    <div className="m-1 mt-2 p-2 bg-gray-100 rounded">

                      <div className="flex justify-between items-center">

                        <div>
                          <p className="text-xs font-bold text-gray-700">
                            Session Q&A Report
                          </p>

                          <p className="text-[10px] text-gray-500 mt-1">
                            Review participation, contribution and responses for{" "}
                            <span className="font-semibold text-orange-600">
                              {cohortName}
                            </span>
                            .
                          </p>
                        </div>


                        <button
                          type="button"
                          onClick={() =>
                            setShowSessionQNAReport(
                              previousValue => !previousValue
                            )
                          }
                          className={`px-3 py-2 rounded-full text-[10px] font-bold border transition ${
                            showSessionQNAReport
                              ? "bg-orange-600 text-white border-orange-600"
                              : "bg-white text-orange-600 border-orange-300 hover:bg-orange-50"
                          }`}
                        >
                          {showSessionQNAReport
                            ? "Close Report"
                            : "View Report"}
                        </button>

                      </div>


                      {showSessionQNAReport && (
                        <div className="mt-2">

                          <EtSessionQNAReportComp
                            orgId={orgId}
                            trailId={trailId}
                            sessionId={sessionId}
                            cohortId={selectedCohortId}
                            handleClose={() =>
                              setShowSessionQNAReport(false)
                            }
                          />

                        </div>
                      )}

                    </div>
                  )} */}


              </div>
              
            )}

            {/* Section 3 - Coach's Session Self Notes */}
            <div className="m-1 p-1 bg-gray-100 rounded">
              <div className="flex justify-between items-center m-1 p-1">
                <div className="flex justify-start items-center m-1 p-1">
                  <div
                    onClick={() => setShowSelfNotes((prev) => !prev)}
                    className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                  >
                    {showSelfNotes ? (
                      <MinusIcon className="h-5 w-5 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-5 w-5 text-orange-600" />
                    )}
                  </div>
                  <div>
                    <EtDocSelfNoteAllUsersIconSVGComp className="h-7 w-7 text-orange-600" />
                  </div>
                  <div>
                    <p className="text-md font-bold text-gray-600 mx-2 px-2">
                      Coach's Session Notes - Self
                    </p>
                    <p className="text-[10px] italic text-gray-600 mx-2 px-2">
                      Capture your session experiences, thoughts and
                      observations about the participants.{" "}
                    </p>
                  </div>
                </div>
              </div>

              {showSelfNotes && (
                <div className="m-2 p-2 bg-gray-300 rounded">
                  <div className="m-1 p-1 border border-white rounded">
                    {coachSelfNotes?.length === 0 && (
                      <div className=" ">
                        <p className="text-[11px] text-gray-500 italic mx-2 px21">
                          No self notes available. Add your first note below.
                        </p>
                      </div>
                    )}

                    {/* Add Note Form */}
                    {isSelfNoteEditing ? (
                      <div className="bg-gray-50 p-1 m-1 rounded">
                        <EtContentEditorLight2
                          value={editorValue}
                          handleChange={handleEditorChange}
                          placeholderText="Write your self note here..."
                          editorKey={selfEditorKey}
                        />
                        <div className="flex justify-start items-center m-1 p-1">
                          <button
                            type="button"
                            onClick={handleSaveSelfNote}
                            className="w-16 text-white rounded-full bg-lime-600 hover:bg-lime-700"
                          >
                            <p className="text-[10px] px-2 py-1">Save</p>
                          </button>
                          <button
                            type="button"
                            onClick={handleCancelEditSelfNote}
                            className="w-16 text-white rounded-full bg-orange-600 hover:bg-orange-700 mx-1"
                          >
                            <p className="text-[10px] px-2 py-1">Cancel</p>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex justify-start items-center m-1 p-1">
                        <p className="font-bold text-xs m-1 p-1">Add</p>
                        <button type="button" onClick={handleAddSelfNote}>
                          <PlusIcon className="h-5 w-5 text-white m-1 p-1 rounded bg-lime-600 hover:bg-green-600" />
                        </button>
                      </div>
                    )}

                    {/* Session Self Note Trail */}

                    <div className="m-1 p-1">
                      <div>
                        <p className="m-1 p-1 text-xs font-bold">
                          Session Notes Trail:
                        </p>
                      </div>
                      <div>
                        {coachSelfNotes
                          ?.slice()
                          .sort(
                            (a, b) =>
                              new Date(b.coachSelfNoteDate) -
                              new Date(a.coachSelfNoteDate)
                          ) // Sort in descending order
                          .map((note, noteIndex, arr) => (
                            <div
                              key={note._id}
                              className="bg-white p-1 m-1 rounded"
                            >
                               {/* 13 Sep 2024 - refined display */}
                               <RenderNotes 
                                  note={note}
                                  noteTextKey="coachSelfNoteText"
                                  updateDateKey="coachSelfNoteUpdateDate"
                                  createdDateKey="coachSelfNoteDate"
                                  showDetail={showCoachSelfAllUsersNoteDetail}
                                  toggleShowDetail={handleToggleCoachSelfAllUsersNoteDetail}
                                  handleEditNote={handleEditSelfNote}
                                  handleDeleteNote={handleDeleteSelfNote}
                                  noteIndex={noteIndex}
                                  arr={arr}
                                  createMarkup={createMarkup}
                                  noteTextSizeClass={selectedNoteTextSizeClass} // 21 Jul 2026
                                />
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Section 4 - Coach's Session All Users Notes */}
            <div className="m-1 p-1 bg-gray-100 rounded">
              <div className="flex justify-between items-center m-1 p-1">
                <div className="flex justify-start items-center m-1 p-1">
                  <div
                    onClick={() => setShowAllUsersNotes((prev) => !prev)}
                    className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                  >
                    {showAllUsersNotes ? (
                      <MinusIcon className="h-5 w-5 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-5 w-5 text-orange-600" />
                    )}
                  </div>
                  <div>
                    <EtDocSharedNoteAllUsersIconSVGComp className="h-7 w-7 text-orange-600" />
                  </div>
                  <div>
                    <p className="text-md font-bold text-gray-600 mx-2 px-2">
                      Coach's Session Notes - All Users
                    </p>
                    <p className="text-[10px] italic text-gray-600 mx-2 px-2">
                      Capture your session experiences, thoughts and
                      observations about the participants which you can share
                      with them.{" "}
                    </p>
                  </div>
                </div>
              </div>

              {showAllUsersNotes && (
                <div className="m-2 p-2 bg-gray-300 rounded">
                  <div className="m-1 p-1 border border-white rounded">
                    {coachAllUsersNotes?.length === 0 && (
                      <div className=" ">
                        <p className="text-[11px] text-gray-500 italic mx-2 px21">
                          No all users notes available. Add your first note
                          below.
                        </p>
                      </div>
                    )}

                    {/* Add Note Form */}
                    {isAllUsersNoteEditing ? (
                      <div className="bg-gray-50 p-1 m-1 rounded">
                        <EtContentEditorLight2
                          value={allUsersEditorValue}
                          handleChange={handleAllUsersEditorChange}
                          placeholderText="Write your all users note here..."
                          editorKey={allUsersEditorKey}
                        />
                        <div className="flex justify-start items-center m-1 p-1">
                          <button
                            type="button"
                            onClick={handleSaveAllUsersNote}
                            className="w-16 text-white rounded-full bg-lime-600 hover:bg-lime-700"
                          >
                            <p className="text-[10px] px-2 py-1">Save</p>
                          </button>
                          <button
                            type="button"
                            onClick={handleCancelEditAllUsersNote}
                            className="w-16 text-white rounded-full bg-orange-600 hover:bg-orange-700 mx-1"
                          >
                            <p className="text-[10px] px-2 py-1">Cancel</p>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex justify-start items-center m-1 p-1">
                        <p className="font-bold text-xs m-1 p-1">Add</p>
                        <button type="button" onClick={handleAddAllUsersNote}>
                          <PlusIcon className="h-5 w-5 text-white m-1 p-1 rounded bg-lime-600 hover:bg-green-600" />
                        </button>
                      </div>
                    )}

                    {/* Session AllUsers Note Trail */}

                    <div className="m-1 p-1">
                      <div>
                        <p className="m-1 p-1 text-xs font-bold">
                          Session Notes Trail:
                        </p>
                      </div>
                      <div>
                        {coachAllUsersNotes
                          ?.slice()
                          .sort(
                            (a, b) =>
                              new Date(b.coachAllUsersNoteDate) -
                              new Date(a.coachAllUsersNoteDate)
                          ) // Sort in descending order
                          .map((note, noteIndex, arr) => (
                            <div
                              key={note._id}
                              className="bg-white p-1 m-1 rounded"
                            >
                              <RenderNotes 
                                  note={note}
                                  noteTextKey="coachAllUsersNoteText"
                                  updateDateKey="coachAllUsersNoteUpdateDate"
                                  createdDateKey="coachAllUsersNoteDate"
                                  showDetail={showCoachAllUsersNoteDetail}
                                  toggleShowDetail={handleToggleCoachAllUsersNoteDetail}
                                  handleEditNote={handleEditAllUsersNote}
                                  handleDeleteNote={handleDeleteAllUsersNote}
                                  noteIndex={noteIndex}
                                  arr={arr}
                                  createMarkup={createMarkup}
                                  noteTextSizeClass={selectedNoteTextSizeClass} // 21 Jul 2026
                                />
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Section 5 - Coach's Session Self User Specific Notes */}
            <div className="m-1 p-1 bg-gray-100 rounded">
              <div className="flex justify-between items-center m-1 p-1">
                <div className="flex justify-start items-center m-1 p-1">
                  <div
                    onClick={() => setShowUserSections((prev) => !prev)}
                    className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                  >
                    {showUserSections ? (
                      <MinusIcon className="h-5 w-5 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-5 w-5 text-orange-600" />
                    )}
                  </div>
                  <div className="">
                    <EtDocSelfUserNoteIconSVGComp className="h-6 w-6 text-orange-600" />
                  </div>
                  <div>
                    <p className="text-md font-bold text-gray-600 mx-2 px-2">
                      Coach's Session Notes - Self - Specific User
                    </p>
                    <p className="text-[10px] italic text-gray-600 mx-2 px-2">
                      Capture your session experiences, thoughts and
                      observations about specific participants.{" "}
                    </p>
                  </div>
                </div>
              </div>

              {/* 26 Jul 2026 */}

              {showUserSections && (
                <div className="m-1 p-1">
                  {/* 26 Jul 2026 - Horizontally scrollable user tabs */}
                  <div className="m-1 rounded border border-gray-200 bg-white">
                    <div className="flex items-center gap-1 p-1">
                      <button
                        type="button"
                        title="Previous users"
                        aria-label="Scroll to previous users"
                        onClick={() =>
                          handleScrollUserTabs(selfNotesUserTabsRef, "left")
                        }
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
                      >
                        <ChevronLeftIcon className="h-5 w-5" />
                      </button>

                      <div
                        ref={selfNotesUserTabsRef}
                        role="tablist"
                        aria-label="Select user for coach self notes"
                        className="flex min-w-0 flex-1 items-stretch gap-1 overflow-x-auto scroll-smooth whitespace-nowrap p-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                      >
                        {filteredSessionUsers?.map((user) => {
                          const userId = user?.userId?._id
                          const isSelected = selectedSelfNotesUserId === userId

                          const userNoteCount =
                            coachSelfUserNotes?.filter(
                              (note) => note.userId === userId
                            )?.length || 0

                          return (
                            <button
                              key={userId}
                              type="button"
                              role="tab"
                              aria-selected={isSelected}
                              onClick={() => setSelectedSelfNotesUserId(userId)}
                              className={`flex shrink-0 items-center gap-2 rounded px-3 py-2 text-left transition ${
                                isSelected
                                  ? "bg-orange-600 text-white shadow-sm"
                                  : "border border-gray-200 bg-gray-50 text-gray-600 hover:border-orange-300 hover:bg-orange-50"
                              }`}
                            >
                              <User
                                username={user.userId?.username}
                                defaultUserPic={userProfileIcon2}
                                compact
                              />

                              <div>
                                <p
                                  className={`text-xs font-bold ${
                                    isSelected ? "text-white" : "text-gray-600"
                                  }`}
                                >
                                  {user.userId?.name}
                                </p>

                                <p
                                  className={`text-[9px] ${
                                    isSelected
                                      ? "text-orange-100"
                                      : "text-gray-400"
                                  }`}
                                >
                                  {userNoteCount}{" "}
                                  {userNoteCount === 1 ? "note" : "notes"}
                                </p>
                              </div>
                            </button>
                          )
                        })}
                      </div>

                      <button
                        type="button"
                        title="Next users"
                        aria-label="Scroll to next users"
                        onClick={() =>
                          handleScrollUserTabs(selfNotesUserTabsRef, "right")
                        }
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
                      >
                        <ChevronRightIcon className="h-5 w-5" />
                      </button>
                    </div>
                  </div>

                  {/* Selected User Notes */}
                  {selectedSelfNotesUser && (
                    <div className="m-1 rounded bg-gray-50 p-1">
                      <div className="m-1 flex items-center gap-2 rounded bg-white p-2">
                        {/* <User
                          username={selectedSelfNotesUser.userId?.username}
                          defaultUserPic={userProfileIcon2}
                        /> */}

                        <div>
                          <p className="text-xs font-bold text-gray-600">
                            {selectedSelfNotesUser.userId?.name}
                          </p>
                          <p className="text-[10px] text-gray-400">
                            {selectedSelfNotesUser.userId?.email}
                          </p>
                        </div>
                      </div>

                  
                      <div className="m-2 rounded bg-gray-300 p-2">
                        <div className="m-1 rounded border border-white p-1">
                          {coachSelfUserNotes?.filter(
                            (note) => note.userId === selectedSelfNotesUserId
                          )?.length === 0 && (
                            <div>
                              <p className="mx-2 text-[11px] italic text-gray-500">
                                No self notes are available for this user. Add the first
                                note below.
                              </p>
                            </div>
                          )}

                          {isSelfUserNoteEditing[selectedSelfNotesUserId] ? (
                            <div className="m-1 rounded bg-gray-50 p-1">
                              <EtContentEditorLight2
                                value={
                                  selfUserEditorValue[selectedSelfNotesUserId] || ""
                                }
                                handleChange={(value) =>
                                  handleSelfUserEditorChange(
                                    value,
                                    selectedSelfNotesUserId
                                  )
                                }
                                placeholderText="Write your private note for this user..."
                                editorKey={
                                  selfUserEditorKey + selectedSelfNotesUserId
                                }
                              />

                              <div className="m-1 flex items-center justify-start p-1">
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleSaveSelfUserNote(
                                      selectedSelfNotesUserId
                                    )
                                  }
                                  className="w-16 rounded-full bg-lime-600 text-white hover:bg-lime-700"
                                >
                                  <p className="px-2 py-1 text-[10px]">Save</p>
                                </button>

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCancelEditSelfUserNote(
                                      selectedSelfNotesUserId
                                    )
                                  }
                                  className="mx-1 w-16 rounded-full bg-orange-600 text-white hover:bg-orange-700"
                                >
                                  <p className="px-2 py-1 text-[10px]">Cancel</p>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="m-1 flex items-center justify-start p-1">
                              <p className="m-1 p-1 text-xs font-bold">Add</p>

                              <button
                                type="button"
                                onClick={() =>
                                  handleAddSelfUserNote(selectedSelfNotesUserId)
                                }
                              >
                                <PlusIcon className="m-1 h-5 w-5 rounded bg-lime-600 p-1 text-white hover:bg-green-600" />
                              </button>
                            </div>
                          )}

                          <div className="m-1 p-1">
                            <p className="m-1 p-1 text-xs font-bold">
                              Session Notes Trail:
                            </p>

                            {coachSelfUserNotes
                              ?.filter(
                                (note) =>
                                  note.userId === selectedSelfNotesUserId
                              )
                              ?.slice()
                              .sort(
                                (a, b) =>
                                  new Date(b.coachSelfUserNoteDate) -
                                  new Date(a.coachSelfUserNoteDate)
                              )
                              .map((note, noteIndex, arr) => (
                                <div
                                  key={note._id}
                                  className="m-1 rounded bg-white p-1"
                                >
                                  <RenderNotes
                                    note={note}
                                    noteTextKey="coachSelfUserNoteText"
                                    updateDateKey="coachSelfUserNoteUpdateDate"
                                    createdDateKey="coachSelfUserNoteDate"
                                    showDetail={showCoachSelfUserNoteDetail}
                                    toggleShowDetail={
                                      handleToggleCoachSelfUserNoteDetail
                                    }
                                    handleEditNote={handleEditSelfUserNote}
                                    handleDeleteNote={handleDeleteSelfUserNote}
                                    noteIndex={noteIndex}
                                    userId={selectedSelfNotesUserId}
                                    arr={arr}
                                    createMarkup={createMarkup}
                                    noteTextSizeClass={selectedNoteTextSizeClass}

                                    // 22 Oct 2026 - Private Coach User Session Evaluation
                                      evaluationPanel={

                                        <EtCoachUserSessionEvalPanel

                                          coachId={coachId}

                                          userId={selectedSelfNotesUserId}

                                          orgId={orgId}

                                          trailId={trailId}

                                          sessionId={sessionId}

                                          coachOrgTrailSessionPadId={padData?._id}

                                          reflectionNoteId={note._id}

                                          reflectionNoteType="coachSessionSelfUserNotes"

                                        />

                                      }
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}



              {/* {showUserSections &&
                filteredSessionUsers &&         // 10 Sep 2024 - changed from sessionUsers to filteredSessionUsers
                filteredSessionUsers?.map((user, userIndex) => {
                  const userId = user.userId?._id
                  // console.log('user id:', userId)

                  return (
                    <div key={userIndex} className="m-1 p-1 bg-gray-50 rounded">
                      <div className="flex justify-between items-center m-1 p-1">
                        <div className=" flex justify-start items-center m-1 p-1">
                          <div
                            onClick={() => handleToggleUserDetails(userId)}
                            className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                          >
                            {showUserSectionDetails[userId] ? (
                              <MinusIcon className="h-5 w-5 text-orange-600" />
                            ) : (
                              <PlusIcon className="h-5 w-5 text-orange-600" />
                            )}
                          </div>

                          <div className="mx-1 px-1">
                            <User
                              username={user.userId?.username}
                              defaultUserPic={userProfileIcon2}
                            />
                          </div>
                          <div className="mx-1 px-1">
                            <p className="text-xs text-gray-600 font-bold">
                              {user.userId?.name}
                            </p>
                            <p className="text-[10px] text-gray-400">
                              {user.userId?.email}
                            </p>
                          </div>
                        </div>
                      </div>

                      {showUserSectionDetails[userId] &&
                        showSelfUserNotes[userId] && (
                          <div className="m-2 p-2 bg-gray-300 rounded">
                            <div className="m-1 p-1 border border-white rounded">
                              {coachSelfUserNotes?.filter(
                                (note) => note.userId === userId
                              )?.length === 0 && (
                                <div className=" ">
                                  <p className="text-[11px] text-gray-500 italic mx-2 px21">
                                    No users notes available. Add your first
                                    note below by selecting a user from the list
                                    below.
                                  </p>
                                </div>
                              )}

                              
                              {isSelfUserNoteEditing[userId] ? (
                                <div className="bg-gray-50 p-1 m-1 rounded">
                                  <EtContentEditorLight2
                                    value={selfUserEditorValue[userId]}
                                    handleChange={(value) =>
                                      handleSelfUserEditorChange(value, userId)
                                    }
                                    placeholderText="Write your all users note here..."
                                    editorKey={selfUserEditorKey + userId}
                                  />
                                  <div className="flex justify-start items-center m-1 p-1">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleSaveSelfUserNote(userId)
                                      }
                                      className="w-16 text-white rounded-full bg-lime-600 hover:bg-lime-700"
                                    >
                                      <p className="text-[10px] px-2 py-1">
                                        Save
                                      </p>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleCancelEditSelfUserNote(userId)
                                      }
                                      className="w-16 text-white rounded-full bg-orange-600 hover:bg-orange-700 mx-1"
                                    >
                                      <p className="text-[10px] px-2 py-1">
                                        Cancel
                                      </p>
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex justify-start items-center m-1 p-1">
                                  <p className="font-bold text-xs m-1 p-1">
                                    Add
                                  </p>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleAddSelfUserNote(userId)
                                    }
                                  >
                                    <PlusIcon className="h-5 w-5 text-white m-1 p-1 rounded bg-lime-600 hover:bg-green-600" />
                                  </button>
                                </div>
                              )}

                             

                              <div className="m-1 p-1">
                                <div>
                                  <p className="m-1 p-1 text-xs font-bold">
                                    Session Notes Trail:
                                  </p>
                                </div>
                                <div>
                                  {coachSelfUserNotes
                                    ?.filter((note) => note.userId === userId)
                                    ?.slice()
                                    .sort(
                                      (a, b) =>
                                        new Date(b.coachSelfUserNoteDate) -
                                        new Date(a.coachSelfUserNoteDate)
                                    ) // Sort in descending order
                                    .map((note, noteIndex, arr) => (
                                      <div
                                        key={note._id}
                                        className="bg-white p-1 m-1 rounded"
                                      >
                                        <RenderNotes 
                                          note={note}
                                          noteTextKey="coachSelfUserNoteText"
                                          updateDateKey="coachSelfUserNoteUpdateDate"
                                          createdDateKey="coachSelfUserNoteDate"
                                          showDetail={showCoachSelfUserNoteDetail}
                                          toggleShowDetail={handleToggleCoachSelfUserNoteDetail}
                                          handleEditNote={handleEditSelfUserNote}
                                          handleDeleteNote={handleDeleteSelfUserNote}
                                          noteIndex={noteIndex}
                                          userId={userId}
                                          arr={arr}
                                          createMarkup={createMarkup}
                                          noteTextSizeClass={selectedNoteTextSizeClass} // 21 Jul 2026
                                        />
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  )
                })} */}
            </div>

            {/* Section 6 - Coach's Session Shared User Specific Notes */}
            <div className="m-1 p-1 bg-gray-100 rounded">
              <div className="flex justify-between items-center m-1 p-1">
                <div className="flex justify-start items-center m-1 p-1">
                  <div
                    onClick={() => setShowSharedUserSections((prev) => !prev)}
                    className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                  >
                    {showSharedUserSections ? (
                      <MinusIcon className="h-5 w-5 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-5 w-5 text-orange-600" />
                    )}
                  </div>
                  <div>
                    <EtDocSharedUserNoteIconSVGComp className="h-6 w-6 text-orange-600" />
                  </div>
                  <div>
                    <p className="text-md font-bold text-gray-600 mx-2 px-2">
                      Coach's Session Notes - Shared - User Specific
                    </p>
                    <p className="text-[10px] italic text-gray-600 mx-2 px-2">
                      Capture your session experiences, thoughts and
                      observations about specific participants which you would
                      share with them.{" "}
                    </p>
                  </div>
                </div>
              </div>

              {/* 26 Jul 2026 */}

              {showSharedUserSections && (
                <div className="m-1 p-1">
                  {/* 26 Jul 2026 - Horizontally scrollable user tabs */}
                  <div className="m-1 rounded border border-gray-200 bg-white">
                    <div className="flex items-center gap-1 p-1">
                      <button
                        type="button"
                        title="Previous users"
                        aria-label="Scroll to previous users"
                        onClick={() =>
                          handleScrollUserTabs(sharedNotesUserTabsRef, "left")
                        }
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
                      >
                        <ChevronLeftIcon className="h-5 w-5" />
                      </button>

                      <div
                        ref={sharedNotesUserTabsRef}
                        role="tablist"
                        aria-label="Select user for shared coach notes"
                        className="flex min-w-0 flex-1 items-stretch gap-1 overflow-x-auto scroll-smooth whitespace-nowrap p-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                      >
                        {filteredSessionUsers?.map((user) => {
                          const userId = user?.userId?._id
                          const isSelected = selectedSharedNotesUserId === userId

                          const userNoteCount =
                            coachSharedUserNotes?.filter(
                              (note) => note.userId === userId
                            )?.length || 0

                          return (
                            <button
                              key={userId}
                              type="button"
                              role="tab"
                              aria-selected={isSelected}
                              onClick={() => setSelectedSharedNotesUserId(userId)}
                              className={`flex shrink-0 items-center gap-2 rounded px-3 py-2 text-left transition ${
                                isSelected
                                  ? "bg-orange-600 text-white shadow-sm"
                                  : "border border-gray-200 bg-gray-50 text-gray-600 hover:border-orange-300 hover:bg-orange-50"
                              }`}
                            >
                              <User
                                username={user.userId?.username}
                                defaultUserPic={userProfileIcon2}
                                compact
                              />

                              <div>
                                <p
                                  className={`text-xs font-bold ${
                                    isSelected ? "text-white" : "text-gray-600"
                                  }`}
                                >
                                  {user.userId?.name}
                                </p>

                                <p
                                  className={`text-[9px] ${
                                    isSelected
                                      ? "text-orange-100"
                                      : "text-gray-400"
                                  }`}
                                >
                                  {userNoteCount}{" "}
                                  {userNoteCount === 1 ? "note" : "notes"}
                                </p>
                              </div>
                            </button>
                          )
                        })}
                      </div>

                      <button
                        type="button"
                        title="Next users"
                        aria-label="Scroll to next users"
                        onClick={() =>
                          handleScrollUserTabs(sharedNotesUserTabsRef, "right")
                        }
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
                      >
                        <ChevronRightIcon className="h-5 w-5" />
                      </button>
                    </div>
                  </div>

                  {/* Selected User Shared Notes */}
                  {selectedSharedNotesUser && (
                    <div className="m-1 rounded bg-gray-50 p-1">
                      <div className="m-1 flex items-center gap-2 rounded bg-white p-2">
                        {/* <User
                          username={selectedSharedNotesUser.userId?.username}
                          defaultUserPic={userProfileIcon2}
                        /> */}

                        <div>
                          <p className="text-xs font-bold text-gray-600">
                            {selectedSharedNotesUser.userId?.name}
                          </p>
                          <p className="text-[10px] text-gray-400">
                            {selectedSharedNotesUser.userId?.email}
                          </p>
                        </div>
                      </div>

                      <div className="m-2 rounded bg-gray-300 p-2">
                        <div className="m-1 rounded border border-white p-1">
                          {coachSharedUserNotes?.filter(
                            (note) => note.userId === selectedSharedNotesUserId
                          )?.length === 0 && (
                            <div>
                              <p className="mx-2 text-[11px] italic text-gray-500">
                                No shared notes are available for this user. Add the
                                first note below.
                              </p>
                            </div>
                          )}

                          {isSharedUserNoteEditing[selectedSharedNotesUserId] ? (
                            <div className="m-1 rounded bg-gray-50 p-1">
                              <EtContentEditorLight2
                                value={
                                  sharedUserEditorValue[selectedSharedNotesUserId] ||
                                  ""
                                }
                                handleChange={(value) =>
                                  handleSharedUserEditorChange(
                                    value,
                                    selectedSharedNotesUserId
                                  )
                                }
                                placeholderText="Write a note to share with this user..."
                                editorKey={
                                  sharedUserEditorKey + selectedSharedNotesUserId
                                }
                              />

                              <div className="m-1 flex items-center justify-start p-1">
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleSaveSharedUserNote(
                                      selectedSharedNotesUserId
                                    )
                                  }
                                  className="w-16 rounded-full bg-lime-600 text-white hover:bg-lime-700"
                                >
                                  <p className="px-2 py-1 text-[10px]">Save</p>
                                </button>

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCancelEditSharedUserNote(
                                      selectedSharedNotesUserId
                                    )
                                  }
                                  className="mx-1 w-16 rounded-full bg-orange-600 text-white hover:bg-orange-700"
                                >
                                  <p className="px-2 py-1 text-[10px]">Cancel</p>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="m-1 flex items-center justify-start p-1">
                              <p className="m-1 p-1 text-xs font-bold">Add</p>

                              <button
                                type="button"
                                onClick={() =>
                                  handleAddSharedUserNote(
                                    selectedSharedNotesUserId
                                  )
                                }
                              >
                                <PlusIcon className="m-1 h-5 w-5 rounded bg-lime-600 p-1 text-white hover:bg-green-600" />
                              </button>
                            </div>
                          )}

                          <div className="m-1 p-1">
                            <p className="m-1 p-1 text-xs font-bold">
                              Session Notes Trail:
                            </p>

                            {coachSharedUserNotes
                              ?.filter(
                                (note) =>
                                  note.userId === selectedSharedNotesUserId
                              )
                              ?.slice()
                              .sort(
                                (a, b) =>
                                  new Date(b.coachSharedUserNoteDate) -
                                  new Date(a.coachSharedUserNoteDate)
                              )
                              .map((note, noteIndex, arr) => (
                                <div
                                  key={note._id}
                                  className="m-1 rounded bg-white p-1"
                                >
                                  <RenderNotes
                                    note={note}
                                    noteTextKey="coachSharedUserNoteText"
                                    updateDateKey="coachSharedUserNoteUpdateDate"
                                    createdDateKey="coachSharedUserNoteDate"
                                    showDetail={showCoachSharedUserNoteDetail}
                                    toggleShowDetail={
                                      handleToggleCoachSharedUserNoteDetail
                                    }
                                    handleEditNote={handleEditSharedUserNote}
                                    handleDeleteNote={handleDeleteSharedUserNote}
                                    noteIndex={noteIndex}
                                    userId={selectedSharedNotesUserId}
                                    arr={arr}
                                    createMarkup={createMarkup}
                                    noteTextSizeClass={selectedNoteTextSizeClass}

                                    // 22 Oct 2026 - Shared Coach User Session Evaluation
                                    evaluationPanel={

                                      <EtCoachUserSessionEvalPanel

                                        coachId={coachId}

                                        userId={selectedSharedNotesUserId}

                                        orgId={orgId}

                                        trailId={trailId}

                                        sessionId={sessionId}

                                        coachOrgTrailSessionPadId={padData?._id}

                                        reflectionNoteId={note._id}

                                        reflectionNoteType="coachSessionSharedUserNotes"

                                      />

                                    }


                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}



              {/* {showSharedUserSections &&
                filteredSessionUsers &&             // 10 Sep 2024 - changed from sessionUsers to filteredSessionUsers
                filteredSessionUsers?.map((user, userIndex) => {
                  const userId = user.userId?._id
                  // console.log('user id:', userId)

                  return (
                    <div key={userIndex} className="m-1 p-1 bg-gray-50 rounded">
                      <div className="flex justify-between items-center m-1 p-1">
                        <div className=" flex justify-start items-center m-1 p-1">
                          <div
                            onClick={() =>
                              handleToggleSharedUserDetails(userId)
                            }
                            className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                          >
                            {showSharedUserSectionDetails[userId] ? (
                              <MinusIcon className="h-5 w-5 text-orange-600" />
                            ) : (
                              <PlusIcon className="h-5 w-5 text-orange-600" />
                            )}
                          </div>

                          <div className="mx-1 px-1">
                            <User
                              username={user.userId?.username}
                              defaultUserPic={userProfileIcon2}
                            />
                          </div>
                          <div className="mx-1 px-1">
                            <p className="text-xs text-gray-600 font-bold">
                              {user.userId?.name}
                            </p>
                            <p className="text-[10px] text-gray-400">
                              {user.userId?.email}
                            </p>
                          </div>
                        </div>
                      </div>

                      {showSharedUserSectionDetails[userId] &&
                        showSharedUserNotes[userId] && (
                          <div className="m-2 p-2 bg-gray-300 rounded">
                            <div className="m-1 p-1 border border-white rounded">
                              {coachSharedUserNotes?.filter(
                                (note) => note.userId === userId
                              )?.length === 0 && (
                                <div className=" ">
                                  <p className="text-[11px] text-gray-500 italic mx-2 px21">
                                    No users notes available. Add your first
                                    note below by selecting a user from the list
                                    below.
                                  </p>
                                </div>
                              )}

                              
                              {isSharedUserNoteEditing[userId] ? (
                                <div className="bg-gray-50 p-1 m-1 rounded">
                                  <EtContentEditorLight2
                                    value={sharedUserEditorValue[userId]}
                                    handleChange={(value) =>
                                      handleSharedUserEditorChange(
                                        value,
                                        userId
                                      )
                                    }
                                    placeholderText="Write your all users note here..."
                                    editorKey={sharedUserEditorKey + userId}
                                  />
                                  <div className="flex justify-start items-center m-1 p-1">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleSaveSharedUserNote(userId)
                                      }
                                      className="w-16 text-white rounded-full bg-lime-600 hover:bg-lime-700"
                                    >
                                      <p className="text-[10px] px-2 py-1">
                                        Save
                                      </p>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleCancelEditSharedUserNote(userId)
                                      }
                                      className="w-16 text-white rounded-full bg-orange-600 hover:bg-orange-700 mx-1"
                                    >
                                      <p className="text-[10px] px-2 py-1">
                                        Cancel
                                      </p>
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex justify-start items-center m-1 p-1">
                                  <p className="font-bold text-xs m-1 p-1">
                                    Add
                                  </p>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleAddSharedUserNote(userId)
                                    }
                                  >
                                    <PlusIcon className="h-5 w-5 text-white m-1 p-1 rounded bg-lime-600 hover:bg-green-600" />
                                  </button>
                                </div>
                              )}

                             

                              <div className="m-1 p-1">
                                <div>
                                  <p className="m-1 p-1 text-xs font-bold">
                                    Session Notes Trail:
                                  </p>
                                </div>
                                <div>
                                  {coachSharedUserNotes
                                    ?.filter((note) => note.userId === userId)
                                    ?.slice()
                                    .sort(
                                      (a, b) =>
                                        new Date(b.coachSharedUserNoteDate) -
                                        new Date(a.coachSharedUserNoteDate)
                                    ) // Sort in descending order
                                    .map((note, noteIndex, arr) => (
                                      <div
                                        key={note._id}
                                        className="bg-white p-1 m-1 rounded"
                                      >
                                        <RenderNotes 
                                          note={note}
                                          noteTextKey="coachSharedUserNoteText"
                                          updateDateKey="coachSharedUserNoteUpdateDate"
                                          createdDateKey="coachSharedUserNoteDate"
                                          showDetail={showCoachSharedUserNoteDetail}
                                          toggleShowDetail={handleToggleCoachSharedUserNoteDetail}
                                          handleEditNote={handleEditSharedUserNote}
                                          handleDeleteNote={handleDeleteSharedUserNote}
                                          noteIndex={noteIndex}
                                          userId={userId}
                                          arr={arr}
                                          createMarkup={createMarkup}
                                          noteTextSizeClass={selectedNoteTextSizeClass} // 21 Jul 2026
                                        />
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  )
                })} */}
            </div>

            {/* Section 7 - Coach's Session Challenge Evaluation - 25 Aug 2024*/}
            {/* 03 Aug 2026 - Old code Replaced with the component placed here */}
            <EtCoachSessionChallengeEvaluations
              sessionChallenges={sessionChallenges || []}
              sessionUsers={filteredSessionUsers || []}
              coachSessionEvals={coachSessionEvals || []}
              coachId={coachId}
              coachOrgId={coachOrgId}

              orgId={orgId}                 // 18 Aug 2026

              trailId={trailId}
              sessionId={sessionId}
              cohortId={selectedCohortId}   // 17 Aug 2026
              userCohortIdByUserId={userCohortIdByUserId}
              refetch={refetch}
            />
            
             {/* Section 8 - Coach's Session Planned User Actions - 01 Sep 2024*/}
             <div className="m-1 p-1 bg-gray-100 rounded">
                <div className="flex justify-between items-center m-1 p-1">
                  <div className="flex justify-start items-center m-1 p-1">
                    <div
                      onClick={() => setShowCoachAllUsersActionsSection((prev) => !prev)}
                      className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                    >
                      {showCoachAllUsersActionsSection ? (
                        <MinusIcon className="h-5 w-5 text-orange-600" />
                      ) : (
                        <PlusIcon className="h-5 w-5 text-orange-600" />
                      )}
                    </div>
                    <div>
                      <EtCoachUserActionIcon1SVGComp className="h-7 w-7 text-orange-600" />
                    </div>
                    <div>
                      <p className="text-md font-bold text-gray-600 mx-2 px-2">
                        Coach's Session Planned Actions
                      </p>
                      <p className="text-[10px] italic text-gray-600 mx-2 px-2">
                        Plan and share actions for all session users
                      </p>
                    </div>
                  </div>
                </div>

                {showCoachAllUsersActionsSection && (
                  <div className="m-1 p-1">
                    {/* Add Planned Actions Button */}

                    <div className="flex justify-start items-center m-1 p-1">
                        <p className="font-bold text-xs m-1 p-1">Add</p>
                        <button type="button" onClick={handleCreatePlannedAction}>
                          <PlusIcon className="h-5 w-5 text-white m-1 p-1 rounded bg-lime-600 hover:bg-green-600" />
                        </button>
                      </div>

                      <div className="m-1 p-1 bg-gray-200 rounded">
                          {/* Planned Actions Header */}
                          <div className="flex justify-start items-center m-1 p-1">
                            <div
                              onClick={() => setShowCoachAllUsersCreatedActions((prev) => !prev)}
                              className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                            >
                              {showCoachAllUsersCreatedActions ? (
                                <MinusIcon className="h-5 w-5 text-orange-600" />
                              ) : (
                                <PlusIcon className="h-5 w-5 text-orange-600" />
                              )}
                            </div>
                            <div>
                                <p className="text-gray-600 font-bold mx-1 px-1">Coach's Planned Actions</p>
                            </div>
                          </div>

                          {showCoachAllUsersCreatedActions && filteredCoachUserPlannedActions && filteredCoachUserPlannedActions?.length>0 &&  filteredCoachUserPlannedActions?.map((action, actionIndex) => {
                            // console.log('planned action:', action)
                            
                            return(
                              <div key={action._id+actionIndex} className="bg-white rounded m-1 p-1">
                                <div className="">  {/* original - bg-gray-50 rounded */}
                                  <div className="grid grid-cols-8 justify-between items-center">
                                    <div className="col-span-5 flex justify-start items-center">

                                          <div
                                            onClick={() => handleToggleCoachUserActionUpdate(action._id)}
                                            className="mx-2 rounded-full h-7 w-7 hover:bg-white flex justify-center items-center cursor-pointer"
                                          >
                                            {showCoachUserActionUpdate[action._id] ? (
                                              <MinusIcon className="h-5 w-5 text-orange-600" />
                                            ) : (
                                              <PlusIcon className="h-5 w-5 text-orange-600" />
                                            )}
                                          </div>

                                          <div><p className="text-[11px] font-bold text-orange-600 mx-1 px-1">{action.coachActionTypeId.actionTypeName}</p></div>
                                          <div><p className="text-[11px] font-bold mx-1">Action {actionIndex+1}.</p></div>
                                          <div><p className="text-[11px] text-gray-600 mx-1">{action.coachSessionActionName}</p></div>
                                    </div>

                                    <div className="col-span-3 flex justify-between items-center ">
                                      <div className="flex justify-start items-center">
                                        <p className="text-gray-600 text-[9px]">Complete by:</p>
                                      <CalendarDaysIcon className="m-2 h-5 w-5 text-orange-600" />
                                      <p className="flex justify-center items-center text-[9px] rounded-full px-2 py-[1px] bg-white border text-gray-600 border-orange-400">
                                        {formatDate(action?.coachSessionActionCompleteBy)}
                                      </p>
                                      </div>
                                      
                                      <div className="flex justify-center items-center">
                                        <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                          <PencilSquareIcon
                                            // 10 Sep 2024 - Add an Onclick function here
                                            onClick={() => handleAddOrUpdatePlannedAction(action)}
                                            className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                                          />
                                        </div>
                                        {/* <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                          <TrashIcon
                                            // Add an Onclick function here
                                            className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                                          />
                                        </div> */}
                                      </div>
                                    </div>

                                  </div>
                                  {/* Show User Action Update for each planned action here*/}
                                  {/* {showCoachUserActionUpdate[action._id] && userCount>0 && sessionUsers?.map((user, userIndex)=> {

                                  })} */}

                                  {/* Show User Action Update for each planned action here */}
                                  {showCoachUserActionUpdate[action._id] && action.sessionUsersActions?.length > 0 && action.sessionUsersActions.map((userAction, userActionIndex) => {
                                    // Find the corresponding user for the userAction
                                    const user = sessionUsers?.find(u => u.userId._id === userAction.userActionId.userId._id);
                                    if (!user) return null;

                                    // Create userInfo object
                                    const userInfo = {
                                      _id: user.userId._id,
                                      username: user.userId.username,
                                      name: user.userId.name,
                                    };

                                    return (
                                      <div key={userAction.userActionId._id + userActionIndex} className="">
                                        {/* Pass userInfo and userActionId to EtUserActionListByIdComp */}
                                        <EtUserActionListByIdComp
                                          userInfo={userInfo}
                                          userActionId={userAction.userActionId._id}
                                          userId={userInfo._id}
                                          trailId={trailId}
                                          sessionId={sessionId}
                                        />
                                      </div>
                                    );
                                  })}

                                  
                                </div>

                              </div>
                            )
                          })}
                  
                    </div>  
                  </div>
                )}
                <EtModalAddOrUpdateCoachUserOrgTrailSessionAction 
                isOpen={isActionModalOpen}
                onClose={handleCloseCreateActionModal}
                coachId={coachId}
                coachOrgId={coachOrgId}
                userOrgId={orgId}
                trailId={trailId}
                sessionId={sessionId}
                triggeringUrl={triggeringActionUrl}
                sessionUsers={filteredSessionUsers}         // 02 Sep 2024 - added to pass sessionUsers , 10 Sep 2024 - updated to filteredSessionUsers
                mode={actionMode} // 10 Sep 2024
                existingActionData={existingActionData} // 10 Sep 2024
                />
             </div>
          </div>
        )}
      </div>
    </div>
  )
}

// 26 Jul 2026
const User = ({ username, defaultUserPic, compact = false }) => {
  const { data: userPic, isFetching: isFetchingUserPic } =
    useGetUserPicQuery(username)

  const wrapperClass = compact
    ? "h-8 w-8 shadow-sm"
    : "h-12 w-12 shadow-lg shadow-black"

  const userPicClass = compact
    ? "h-7 w-7"
    : "h-11 w-11"

  const defaultPicClass = compact
    ? "h-7 w-7 p-1"
    : "h-10 w-10 p-1"

  return (
    <div
      className={`flex shrink-0 cursor-pointer items-center justify-center rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 ${wrapperClass}`}
    >
      {isFetchingUserPic ? (
        <div className="text-[8px]">...</div>
      ) : userPic ? (
        <img
          src={userPic}
          alt="User"
          className={`${userPicClass} rounded-full`}
        />
      ) : (
        <img
          src={defaultUserPic}
          alt="User"
          className={defaultPicClass}
        />
      )}
    </div>
  )
}

// const User = ({ username, defaultUserPic }) => {
//   const { data: userPic, isFetching: isFetchingUserPic } =
//     useGetUserPicQuery(username)

//   return (
//     <div className="flex justify-center items-center h-12 w-12 rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 shadow-lg shadow-black cursor-pointer">
//       {/* Display user picture or loading indicator*/}
//       {isFetchingUserPic ? (
//         <div>Loading...</div>
//       ) : userPic ? (
//         <img src={userPic} alt="User" className="h-11 w-11  rounded-full" />
//       ) : (
//         <img src={defaultUserPic} alt="User" className="h-10 w-10 p-1" />
//       )}
//     </div>
//   )
// }

// 30 Aug 2024 - Helper function to render user info and evaluation comments


const renderUserEvalInfo = (user, coachEvalText, evalUpdateDate, textColor = "text-gray-800") => (
  <div className="flex flex-col items-start justify-start mx-1 px-1">
      <div className="flex justify-start items-center w-full">
          <div className="flex justify-start items-center m-1 p-1 w-16">
              {/* User Info */}
              <div className="flex flex-col justify-center items-center">
                  <div className="w-16">
                      <p className="text-orange-600 text-[9px] text-center">
                          User
                      </p>
                  </div>
                  <div className="mx-1 px-1">
                      <User
                          username={user.userId?.username}
                          defaultUserPic={userProfileIcon2}
                      />
                  </div>
                  <div className="w-16 my-1 py-1">
                      <p className="text-gray-600 text-[10px] text-center">
                          {user.userId?.name.split(" ")[0]}
                      </p>
                  </div>
              </div>
          </div>
          <div className="m-1 p-1 border-l-2 border-orange-600">
              <div>
                  <p className="mx-1 text-gray-600 font-bold text-[10px]">
                      Comments
                  </p>
              </div>
              <div>
                  <p className={`mx-1 ${textColor} text-[10px]`}>
                      {coachEvalText}
                  </p>
              </div>
          </div>
      </div>

      <div className="m-1 p-1">
          <div className="flex justify-start items-center">
              <ClockIcon className="h-5 w-5 text-lime-600" />
              <p className="mx-1 px-1 text-gray-500 text-[10px] font-bold">
                  Last Updated
              </p>
              <p className="text-[9px] mx-1 italic px-2 py-1 text-gray-400">
                  {getTimeSince(evalUpdateDate)}
              </p>
          </div>
      </div>
  </div>
);

// 13 Sep 2024 - Component for rendering coach's notes
const RenderNotes = ({
  note,
  noteTextKey,           // e.g., "coachSharedUserNoteText", "coachAllUsersNoteText"
  updateDateKey,         // e.g., "coachSharedUserNoteUpdateDate", "coachAllUsersNoteUpdateDate"
  createdDateKey,        // e.g., "coachSharedUserNoteDate", "coachAllUsersNoteDate"
  showDetail,            // State variable controlling visibility of full note
  toggleShowDetail,      // Function to toggle visibility
  handleEditNote,        // Function to handle editing of the note
  handleDeleteNote,      // Function to handle deletion of the note
  noteIndex,
  userId,
  arr,
  createMarkup,
  noteTextSizeClass = "text-sm leading-6", // 21 Jul 2026
  // 22 Oct 2026 - Optional note-specific evaluation workspace
  evaluationPanel = null,
}) => {

  const noteText = note[noteTextKey];
  const updateDate = note[updateDateKey];
  const createdDate = note[createdDateKey];
  const noteId = note._id;

  // 21 Jul 2026 - Text size independently selectable for this note
  const [localNoteTextSizeClass, setLocalNoteTextSizeClass] =
    useState(noteTextSizeClass)

  // Keep each note aligned when the page level text size changes
  useEffect(() => {
    setLocalNoteTextSizeClass(noteTextSizeClass)
  }, [noteTextSizeClass])

  const noteTextSizeOptions = [
    {
      value: "small",
      label: "S",
      title: "Small text",
      className: "text-[11px] leading-5",
    },
    {
      value: "medium",
      label: "M",
      title: "Medium text",
      className: "text-sm leading-6",
    },
    {
      value: "large",
      label: "L",
      title: "Large text",
      className: "text-base leading-7",
    },
    {
      value: "extraLarge",
      label: "XL",
      title: "Extra large text",
      className: "text-lg leading-8",
    },
  ]

  return (
    noteText.length > 0 && (
      <div className="bg-gray-100 m-1 p-1 rounded">
        <div className="grid grid-cols-8 justify-between items-center m-1 p-1">
          <div className="col-span-1 flex justify-start items-center">
            <div
              onClick={() => toggleShowDetail(noteId)}
              className="mx-1 rounded-full h-6 w-6 hover:bg-white flex justify-center items-center cursor-pointer"
            >
              {showDetail[noteId] ? (
                <MinusIcon className="h-4 w-4 text-orange-600" />
              ) : (
                <PlusIcon className="h-4 w-4 text-orange-600" />
              )}
            </div>
            <div>
              {/* <p className="text-2xl font-bold mx-1 px-1 text-gray-600">{arr.length - noteIndex}.</p> */}
              <p className="text-2xl font-bold mx-1 px-1 text-gray-600">{ noteIndex +1}.</p>
            </div>
            <div>
              <p className="text-[9px] mx-1 rounded-full px-2 py-[1px] bg-lime-200 w-18">
                {getTimeSince(updateDate)}
              </p>
              <p className="text-[7px] mx-1 italic px-2 py-1 text-gray-400">last updated</p>
            </div>
          </div>

          <div className="col-span-4 flex justify-start items-center">
            <div
              dangerouslySetInnerHTML={createMarkup(noteText)}
              className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
            ></div>
          </div>

          <div className="col-span-2 flex justify-start items-center mx-2">
            <ClockIcon className="h-5 w-5 text-lime-600" />
            <p className="text-[9px] mx-1">First Created:</p>
            <p className="text-gray-400 text-[9px] mx-2">{formatDateTime(createdDate)}</p>
          </div>

          <div className="col-span-1 flex justify-start items-center mx-2">
            <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
              <PencilSquareIcon
                className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                // onClick={() => handleEditNote(userId, note)}
                onClick={() => (userId ? handleEditNote(userId, note) : handleEditNote(note))}
              />
            </div>
            <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
              <TrashIcon
                className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                onClick={() => handleDeleteNote(noteId)}
              />
            </div>
          </div>
        </div>

        {showDetail[noteId] && (
          <div className="m-1 p-1 rounded bg-gray-50">

            {/* 21 Jul 2026 - Note level text size selector */}
            <div className="flex justify-end items-center mb-1">
              <div className="flex items-center gap-1 rounded border border-gray-200 bg-gray-50 px-2 py-1">
                <p className="mr-1 text-[9px] font-semibold text-gray-500">
                  Text:
                </p>

                {noteTextSizeOptions.map((sizeOption) => {
                  const isSelected =
                    localNoteTextSizeClass === sizeOption.className

                  return (
                    <button
                      key={sizeOption.value}
                      type="button"
                      title={sizeOption.title}
                      aria-label={sizeOption.title}
                      aria-pressed={isSelected}
                      onClick={() =>
                        setLocalNoteTextSizeClass(sizeOption.className)
                      }
                      className={`min-w-7 rounded px-2 py-1 text-[9px] font-semibold transition ${
                        isSelected
                          ? "bg-orange-600 text-white shadow-sm"
                          : "border border-gray-200 bg-white text-gray-500 hover:border-orange-300 hover:text-orange-600"
                      }`}
                    >
                      {sizeOption.label}
                    </button>
                  )
                })}
              </div>
            </div>

            <div
              dangerouslySetInnerHTML={createMarkup(noteText)}
              className={`${localNoteTextSizeClass} text-gray-800 m-1 p-1 fix-nested-lists`} // 21 Jul 2026
              // className={`${noteTextSizeClass} text-gray-700 m-1 p-1 fix-nested-lists`} // 21 Jul 2026
              // className="fix-nested-lists text-[11px] text-gray-700 m-1 p-1"
            ></div>
            {/* 22 Oct 2026 - Coach User Session Progress Evaluation */}
            {evaluationPanel}
          </div>
        )}
      </div>
    )
  );
}

export default EtCoachOrgTrailSessionPadCompProd